// mnl-header.js — V872 : module header extrait de sections/header.liquid (56 KB inline → asset cacheable, defer).
// Config injectée par la section AVANT ce script : window.__MNL_HDR_CFG = { searchUrl, pwUrl, isCustomer }.
// PIÈGE : pas de délimiteurs Liquid dans les commentaires (push Shopify les parse).

(function(){
  var hd = document.getElementById('mnl-hd');
  if (!hd) return;
  var _searchDebug = initSearchPhoneTrace();
  if (_searchDebug) _searchDebug('boot');

  function initSearchPhoneTrace(){
    try {
      if (new URLSearchParams(window.location.search).get('mnl_search_debug') !== '1') return null;
      var dialog = document.getElementById('mnl-hd-drawer-search');
      if (!dialog) return null;
      var panel = document.createElement('pre');
      panel.id = 'mnl-search-phone-trace';
      panel.setAttribute('aria-hidden', 'true');
      panel.style.cssText = 'position:fixed;left:8px;right:8px;bottom:8px;z-index:2147483647;max-height:28vh;max-height:28dvh;overflow:hidden;box-sizing:border-box;margin:0;padding:8px;border:1px solid #fff;border-radius:8px;background:#111;color:#fff;font:10px/1.3 monospace;white-space:pre-wrap;overflow-wrap:anywhere;pointer-events:none;user-select:none;opacity:.94';
      dialog.appendChild(panel);
      var rows = [], started = Date.now(), pending = false, point = '?', pointX = null, pointY = null;
      var counts = { boot: 0, ready: 0, down: 0, up: 0, start: 0, end: 0, click: 0, close: 0 };
      function targetName(target){
        var element = target && target.nodeType === 1 ? target : target && target.parentElement;
        if (!element || !element.closest) return 'other';
        if (element.closest('#mnl-hd-drawer-search [data-mnl-search-dismiss] button[data-mnl-close]')) return 'cross';
        if (element.closest('#mnl-hd-search-input')) return 'input';
        if (element === dialog) return 'dialog';
        if (dialog.contains(element)) return 'inside';
        return 'other';
      }
      function state(){
        var name = hd.dataset.open;
        if (!name) name = 'none';
        else if (['search', 'menu', 'cart', 'account'].indexOf(name) === -1) name = 'other';
        var hidden = dialog.getAttribute('aria-hidden');
        return 'O' + Number(!!dialog.open) + ' A' + (hidden === 'true' ? '1' : hidden === 'false' ? '0' : '?') + ' I' + Number(!!dialog.inert) + ' H:' + name + ' L' + Number(document.body.classList.contains('mnl-hd-locked'));
      }
      function record(label){
        try {
          if (label === 'boot') counts.boot++;
          if (label === 'bindings-ready') counts.ready++;
          if (label === 'close-enter') counts.close++;
          rows.push((Date.now() - started) + ' ' + label + ' ' + state());
          if (rows.length > 6) rows.shift();
          if (pending) return;
          pending = true;
          setTimeout(function(){
            try {
              pending = false;
              var button = dialog.querySelector('[data-mnl-search-dismiss] button[data-mnl-close]');
              var rect = button && button.getBoundingClientRect();
              var geometry = rect ? [rect.x, rect.y, rect.width, rect.height].map(Math.round).join(',') : '?';
              var viewport = window.visualViewport;
              var pointer = button ? window.getComputedStyle(button).pointerEvents : '';
              if (pointer !== 'none' && pointer !== 'auto') pointer = 'other';
              var flags = button ? Number(!!button.disabled) + '/' + Number(!!button.closest('[inert]')) + '/' + pointer : '?';
              var hit = '?';
              if (pointX !== null && typeof document.elementsFromPoint === 'function') hit = document.elementsFromPoint(pointX, pointY).slice(0, 3).map(targetName).join('>') || 'none';
              panel.textContent = 'TRACE SPT1 local B' + counts.boot + ' R' + counts.ready + ' D' + counts.down + ' U' + counts.up + ' T' + counts.start + '/' + counts.end + ' C' + counts.click + ' F' + counts.close + '\n' + state() + ' X:' + flags + '\nR:' + geometry + ' P:' + point + ' V:' + (viewport ? Math.round(viewport.height) + '/' + Math.round(viewport.offsetTop) + '/' + Math.round(viewport.scale * 100) / 100 : '?') + '\nHit:' + hit + '\n' + rows.join('\n');
            } catch (_) { pending = false; }
          }, 0);
        } catch (_) {}
      }
      ['pointerdown', 'pointerup', 'pointercancel', 'touchstart', 'touchend', 'touchcancel', 'click', 'focusout'].forEach(function(type){
        window.addEventListener(type, function(event){
          try {
          var target = targetName(event.target);
          if (!dialog.open && hd.dataset.open !== 'search' && target !== 'cross' && target !== 'input') return;
          if (target === 'cross') {
            var key = { pointerdown: 'down', pointerup: 'up', touchstart: 'start', touchend: 'end', click: 'click' }[type];
            if (key) counts[key]++;
          }
          var contact = event.changedTouches && event.changedTouches[0] || event;
          if (typeof contact.clientX === 'number' && typeof contact.clientY === 'number') { pointX = Math.round(contact.clientX); pointY = Math.round(contact.clientY); point = pointX + ',' + pointY; }
          record(type + ':' + target + ' p' + Number(event.defaultPrevented) + ' c' + Number(event.cancelable));
          setTimeout(function(){ record(type + ':after p' + Number(event.defaultPrevented)); }, 0);
          } catch (_) {}
        }, { passive: true, capture: true });
      });
      ['close', 'cancel'].forEach(function(type){ dialog.addEventListener(type, function(){ record('native-' + type); }, { passive: true }); });
      var observer = new MutationObserver(function(){ record('state-change'); });
      observer.observe(dialog, { attributes: true, attributeFilter: ['open', 'aria-hidden', 'inert'] });
      observer.observe(hd, { attributes: true, attributeFilter: ['data-open'] });
      observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      if (window.visualViewport) window.visualViewport.addEventListener('resize', function(){ record('viewport-resize'); }, { passive: true });
      window.addEventListener('error', function(event){
        if (typeof event.filename === 'string' && /\/mnl-header\.js(?:[?.]|$)/.test(event.filename)) record('header-error');
      }, { passive: true });
      return record;
    } catch (_) { return null; }
  }

  // Vague 131 : notification bell — système de notifications locales (achievements, sub, formula saved, etc.)
  // Architecture: window.mnlNotifAdd({icon, title, sub, url, ts?}) ajoute une notif persistante localStorage.
  (function _notifCenter(){
    var btn = document.getElementById('mnl-hd-notif-btn');
    var panel = document.getElementById('mnl-hd-notif-panel');
    var badge = document.getElementById('mnl-hd-notif-badge');
    var listEl = document.getElementById('mnl-hd-notif-list');
    var clearBtn = document.getElementById('mnl-hd-notif-clear');
    if (!btn || !panel || !listEl) return;
    var NOTIF_KEY = 'mnl-notifs';
    var MAX_NOTIFS = 30;
    function _load(){
      try { return JSON.parse(localStorage.getItem(NOTIF_KEY) || '[]'); } catch(_){ return []; }
    }
    function _save(arr){
      try { localStorage.setItem(NOTIF_KEY, JSON.stringify(arr.slice(0, MAX_NOTIFS))); } catch(_){}
    }
    function _esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
    function _fmtTime(ts){
      var diff = Date.now() - ts;
      if (diff < 60000) return MNL_T('header-polish.time_now', "à l'instant");
      if (diff < 3600000) return Math.floor(diff / 60000) + MNL_T('header-polish.time_minutes_suffix', ' min');
      if (diff < 86400000) return Math.floor(diff / 3600000) + MNL_T('header-polish.time_hours_suffix', 'h');
      if (diff < 7 * 86400000) return Math.floor(diff / 86400000) + MNL_T('header-polish.time_days_suffix', 'j');
      return new Date(ts).toLocaleDateString('fr-FR');
    }
    function _render(){
      var notifs = _load();
      var unreadCount = notifs.filter(function(n){ return !n.read; }).length;
      if (unreadCount > 0) { badge.textContent = unreadCount > 9 ? '9+' : String(unreadCount); badge.hidden = false; }
      else { badge.hidden = true; }
      if (!notifs.length) {
        listEl.innerHTML = MNL_T('header-polish.notif_empty_html', '<p class="mnl-hd-notif-empty">Aucune notification pour le moment <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block;vertical-align:-2px" aria-hidden="true"><path d="M12 3l1.7 4.8L18.5 9.5l-4.8 1.7L12 16l-1.7-4.8L5.5 9.5l4.8-1.7z"/></svg></p>');
        return;
      }
      listEl.innerHTML = notifs.map(function(n, idx){
        var tag = n.url ? 'a' : 'div';
        var attrs = n.url ? ' href="' + _esc(n.url) + '"' : '';
        return '<' + tag + attrs + ' class="mnl-hd-notif-item' + (n.read ? '' : ' is-unread') + '" data-notif-idx="' + idx + '">' +
          '<span class="mnl-hd-notif-item__icon" aria-hidden="true">' + _esc(n.icon || '') + '</span>' +
          '<div class="mnl-hd-notif-item__txt">' +
            '<p class="mnl-hd-notif-item__title">' + _esc(n.title || '') + '</p>' +
            (n.sub ? '<p class="mnl-hd-notif-item__sub">' + _esc(n.sub) + '</p>' : '') +
            '<span class="mnl-hd-notif-item__time">' + _fmtTime(n.ts) + '</span>' +
          '</div>' +
        '</' + tag + '>';
      }).join('');
    }
    function _markAllRead(){
      var notifs = _load().map(function(n){ n.read = true; return n; });
      _save(notifs);
      _render();
    }
    // Open/close panel
    function _toggle(){
      var open = !panel.hidden;
      if (open) {
        panel.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        document.removeEventListener('click', _outside, true);
      } else {
        _render();
        panel.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
        // Auto-mark all as read 1.5s après ouverture (laisse temps de voir le badge unread)
        setTimeout(_markAllRead, 1500);
        setTimeout(function(){
          document.addEventListener('click', _outside, true);
        }, 0);
      }
    }
    function _outside(e){
      if (!panel.contains(e.target) && e.target !== btn && !btn.contains(e.target)) _toggle();
    }
    btn.addEventListener('click', function(e){ e.stopPropagation(); _toggle(); });
    if (clearBtn) clearBtn.addEventListener('click', function(){
      var notifs = _load().map(function(n){ n.read = true; return n; });
      _save(notifs);
      _render();
      if (window.mnlToast) window.mnlToast({ icon: '✓', title: MNL_T('header-polish.notif_marked_read', 'Notifications marquées lues'), type: 'success', duration: 1500 });
    });
    // API publique
    window.mnlNotifAdd = function(notif){
      if (!notif || !notif.title) return;
      var notifs = _load();
      notifs.unshift({
        icon: notif.icon || '',
        title: String(notif.title).slice(0, 80),
        sub: notif.sub ? String(notif.sub).slice(0, 140) : '',
        url: notif.url || null,
        ts: notif.ts || Date.now(),
        read: false
      });
      _save(notifs);
      _render();
    };
    window.mnlNotifClear = function(){ _save([]); _render(); };
    // Render initial
    _render();
  })();

  // Vague 128 : cart hover preview desktop — fetch /cart.js et affiche les items en tooltip riche
  (function _cartHoverPreview(){
    var wrap = document.getElementById('mnl-hd-cart-wrap');
    var preview = document.getElementById('mnl-hd-cart-preview');
    if (!wrap || !preview) return;
    // Skip mobile (CSS le cache mais évite fetch inutile)
    if (window.matchMedia && window.matchMedia('(max-width: 1023px)').matches) return;
    var _hoverTimer = null;
    var _hideTimer = null;
    var _lastFetch = 0;
    function _fmt(c){ return ((c || 0) / 100).toFixed(2).replace('.', ',') + ' €'; }
    function _esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
    function _renderCart(cart){
      var body = document.getElementById('mnl-hd-cart-preview-body');
      var count = document.getElementById('mnl-hd-cart-preview-count');
      var total = document.getElementById('mnl-hd-cart-preview-total');
      if (!body) return;
      var items = (cart && cart.items) || [];
      // V3.0 fix : compter les UNITÉS (cart.item_count) pas les LIGNES (items.length) — cohérence avec
      // le badge de l'icône panier et le tiroir. Avant : panier de 3 articles sur 2 lignes affichait « 2 articles ».
      var _itemTotal = (cart && cart.item_count != null) ? cart.item_count : items.length;
      if (count) count.textContent = _itemTotal + MNL_T('wishlist.js_article_word', ' article') + (_itemTotal > 1 ? MNL_T('wishlist.js_article_plural', 's') : '');
      if (total) total.textContent = _fmt(cart && cart.total_price || 0);
      if (!items.length) {
        body.innerHTML = MNL_T('header-polish.cart_preview_empty_html', '<p class="mnl-hd-cart-preview__empty">Panier vide</p>');
        return;
      }
      // Show max 4 items dans le preview
      body.innerHTML = items.slice(0, 4).map(function(it){
        var img = it.image ? '<img src="' + _esc(it.image) + '" alt="" loading="lazy">' : '';
        var variant = (it.variant_title && it.variant_title !== 'Default Title') ? ' · ' + _esc(it.variant_title).slice(0, 20) : '';
        return '<div class="mnl-hd-cart-preview__item">' +
          '<div class="mnl-hd-cart-preview__item-img">' + img + '</div>' +
          '<div class="mnl-hd-cart-preview__item-info">' +
            '<div class="mnl-hd-cart-preview__item-title">' + _esc(it.product_title) + '</div>' +
            '<div class="mnl-hd-cart-preview__item-meta">x' + it.quantity + variant + '</div>' +
          '</div>' +
          '<div class="mnl-hd-cart-preview__item-price">' + _fmt(it.final_line_price) + '</div>' +
        '</div>';
      }).join('') + (items.length > 4 ? '<p style="text-align:center;color:#94a3b8;font-size:11px;margin:6px 0 0;">+ ' + (items.length - 4) + MNL_T('header.cart_preview_other_word', ' autre') + (items.length - 4 > 1 ? MNL_T('header.cart_preview_other_plural_s', 's') : '') + '</p>' : '');
    }
    function _fetchAndShow(){
      // Cache 10s pour éviter spam si user hover rapide
      var now = Date.now();
      if (now - _lastFetch > 10000 || !wrap._mnlCartCache) {
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function(r){ return r.json(); })
          .then(function(cart){
            wrap._mnlCartCache = cart;
            _lastFetch = now;
            _renderCart(cart);
            _show();
          }).catch(function(){
            // Fail silently — pas bloquant
          });
      } else {
        _renderCart(wrap._mnlCartCache);
        _show();
      }
    }
    function _show(){
      preview.hidden = false;
      requestAnimationFrame(function(){ preview.classList.add('is-visible'); });
    }
    function _hide(){
      preview.classList.remove('is-visible');
      setTimeout(function(){ preview.hidden = true; }, 220);
    }
    wrap.addEventListener('mouseenter', function(){
      if (_hideTimer) { clearTimeout(_hideTimer); _hideTimer = null; }
      if (_hoverTimer) clearTimeout(_hoverTimer);
      // Delay 300ms pour éviter flash si user juste swipe la souris
      _hoverTimer = setTimeout(_fetchAndShow, 300);
    });
    wrap.addEventListener('mouseleave', function(){
      if (_hoverTimer) { clearTimeout(_hoverTimer); _hoverTimer = null; }
      _hideTimer = setTimeout(_hide, 200);
    });
    // Invalidate cache si cart update event
    document.addEventListener('mnl:cart:updated', function(){ _lastFetch = 0; });
  })();

  // ════════════ SCROLL : header slim + promo bar collapse + progress bar ════════════
  // Vague 127 : ajout 2e palier 'is-compact' au scroll > 240px — encore plus minimal pour libérer viewport
  var lastScroll = 0;
  var progressFill = document.getElementById('mnl-hd-progress-fill');
  // Vague 150 P1 PERF FIX : rAF throttle pour éviter jank mobile (avant : exécuté à chaque scroll event, ~120Hz sur trackpads modernes)
  var _scrollTicking = false;
  function _doScroll(){
    var s = window.pageYOffset;
    /* V977 : HYSTÉRÉSIS anti-pompage (signalé fondateur « le header a un mouvement étrange au
       scroll sur téléphone ») — l'ancien seuil unique 40px faisait osciller le repli du bandeau
       promo (28px de haut) : au voisinage du seuil, chaque micro-scroll inversait l'état et le
       header pompait. Deux seuils écartés (repli > 72, redéploiement < 8) + zone morte entre
       les deux = une bascule franche, jamais de flip-flop. Idem is-compact (240/180). */
    if (s > 72) hd.classList.add('is-scrolled');
    else if (s < 8) hd.classList.remove('is-scrolled');
    if (s > 240) hd.classList.add('is-compact');
    else if (s < 180) hd.classList.remove('is-compact');
    if (progressFill) {
      var docH = (document.documentElement.scrollHeight - window.innerHeight) || 1;
      var pct = Math.min(100, Math.max(0, (s / docH) * 100));
      progressFill.style.width = pct.toFixed(1) + '%';
    }
    lastScroll = s;
    _scrollTicking = false;
  }
  function handleScroll(){
    if (_scrollTicking) return;
    _scrollTicking = true;
    requestAnimationFrame(_doScroll);
  }
  window.addEventListener('scroll', handleScroll, { passive: true });
  _doScroll();
  /* V1018 : les transitions du header sont coupées par CSS tant que .is-ready est absent
     (fin de mnl-header.css) — sans ça, le is-scrolled posé ici APRÈS le premier paint animait
     le repli du bandeau promo 350ms au chargement des pages ouvertes déjà scrollées (« header
     décalé puis se remet », fondateur). Double rAF = l'état initial est peint AVANT de
     réactiver les animations ; le comportement au scroll reste identique. */
  requestAnimationFrame(function(){ requestAnimationFrame(function(){ hd.classList.add('is-ready'); }); });

  // ════════════ MEGA MENU : hover + click + keyboard (accessibility WCAG 2.1.1) ════════════
  // Vague 103 : avant, le mega-menu n'ouvrait QUE sur hover → inaccessible clavier (user qui
  // navigue avec Tab + Enter ne pouvait jamais déployer le menu). Maintenant : click + Enter/Espace
  // toggle l'état, focusout délai ferme, hover préservé pour compat souris.
  var megaWraps = document.querySelectorAll('[data-mnl-mega]');
  megaWraps.forEach(function(wrap){
    var trigger = wrap.querySelector('.mnl-hd-desktop-nav__link');
    if (trigger) {
      trigger.setAttribute('aria-haspopup', 'true');
      trigger.setAttribute('aria-expanded', 'false');
    }
    var hoverTimer;
    function _open(){
      clearTimeout(hoverTimer);
      wrap.classList.add('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }
    function _close(){
      wrap.classList.remove('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }
    function _toggle(){
      if (wrap.classList.contains('is-open')) _close(); else _open();
    }
    wrap.addEventListener('mouseenter', _open);
    wrap.addEventListener('mouseleave', function(){
      hoverTimer = setTimeout(_close, 120);
    });
    // Vague 103 : click toggle (mobile touch + accessibility) — preventDefault si l'href est `#` ou pointe vers
    // la page courante (sinon laisse la navigation se faire normalement).
    if (trigger) {
      trigger.addEventListener('click', function(e){
        var href = trigger.getAttribute('href') || '';
        // Si href = # ou même path que la page courante, on intercepte le click pour toggle
        if (href === '#' || href === '' || href === location.pathname) {
          e.preventDefault();
          _toggle();
        }
      });
      // Vague 103 : Enter/Espace sur trigger keyboard-focused = toggle
      trigger.addEventListener('keydown', function(e){
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          _toggle();
        }
      });
    }
    // Vague 103 : focusout délai 200ms — ferme si focus quitte tout le wrap (Tab vers prochain item)
    wrap.addEventListener('focusout', function(e){
      setTimeout(function(){
        if (!wrap.contains(document.activeElement)) _close();
      }, 200);
    });
    // Échap ferme la mega
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && wrap.classList.contains('is-open')) {
        _close();
        if (trigger) trigger.focus(); // restore focus sur trigger
      }
    });
  });

  // ════════════ ACTIVE PAGE HIGHLIGHTING (V246+V247 — match robuste + redirect-aware) ════════════
  // V246 : normalisation paths (trailing slash, casse, query) + match strict prefix avec délimiteur
  // V247 : match aussi via canonical URL (handle les renames Shopify : /pages/le-lab → 301 /pages/lab)
  //        + match via title fuzzy (anti slug-mismatch type "notre-histoire" vs handle "histoire")
  try {
    function _normalize(p) {
      if (!p) return '/';
      p = p.toLowerCase().replace(/^https?:\/\/[^/]+/, '').split('?')[0].split('#')[0];
      // Strip trailing slash sauf si root
      if (p.length > 1 && p.charAt(p.length - 1) === '/') p = p.slice(0, -1);
      return p || '/';
    }
    // V247 : récupère aussi la canonical URL (= la VRAIE URL finale après redirects 301 Shopify)
    var canonical = '';
    try {
      var canonEl = document.querySelector('link[rel="canonical"]');
      if (canonEl) canonical = _normalize(canonEl.getAttribute('href') || '');
    } catch(_){}
    var path = _normalize(window.location.pathname);
    // Set de paths candidats à matcher : path courant + canonical (souvent identiques mais parfois différent)
    var candidatePaths = [path];
    if (canonical && canonical !== path) candidatePaths.push(canonical);

    var navLinks = document.querySelectorAll('.mnl-hd-desktop-nav__link');
    navLinks.forEach(function(a){
      var href = a.getAttribute('href') || '';
      if (!href || href === '#') return;
      var aPath = _normalize(href);
      // Cas spécial : home
      if (aPath === '/') {
        if (path === '/' || canonical === '/') a.classList.add('is-active');
        return;
      }
      // V247 : tente chaque candidate path (current + canonical)
      var matched = false;
      for (var i = 0; i < candidatePaths.length; i++) {
        var cp = candidatePaths[i];
        // Match exact OU prefix avec délimiteur "/" (évite /pages/le-lab-extra matching /pages/le-lab)
        if (cp === aPath || cp.indexOf(aPath + '/') === 0) {
          matched = true;
          break;
        }
        // V247 : match inverse — si l'href est un slug LONG et le path actuel un slug COURT (redirect),
        //   ex: href=/pages/le-lab ET path=/pages/lab → tente d'extraire le slug et le matcher
        var aPathSlug = aPath.split('/').pop();
        var cpSlug = cp.split('/').pop();
        if (aPathSlug && cpSlug && aPathSlug.length >= 3 && cpSlug.length >= 3) {
          // Match si l'un contient l'autre (le-lab contient lab, ou vice versa)
          if (aPathSlug.indexOf(cpSlug) !== -1 || cpSlug.indexOf(aPathSlug) !== -1) {
            // Sécurité : les 2 paths doivent partager le même préfixe "/pages/" ou "/products/" etc.
            var aPrefix = aPath.substring(0, aPath.lastIndexOf('/'));
            var cpPrefix = cp.substring(0, cp.lastIndexOf('/'));
            if (aPrefix === cpPrefix) {
              matched = true;
              break;
            }
          }
        }
      }
      if (matched) a.classList.add('is-active');
    });
  } catch(_){}

  // [SUPPRIMÉ] Mega menu live counter "X personnes configurent leur formule" — fake JS-random retiré.
  // Remplacé par "Marque française · Fabriqué à la commande" (statement non chiffré, conforme DGCCRF). V516 : ex "Made in France".

  // ════════════ PROMO BAR : rotation auto des messages ════════════
  var promoTrack = document.getElementById('mnl-hd-promo-track');
  if (promoTrack) {
    var msgs = promoTrack.querySelectorAll('.mnl-hd-promo__msg');
    var realCount = msgs.length - 1; // dernier est dupliqué
    var idx = 0;
    // Hauteur lue dynamiquement depuis le DOM (responsive : 34px mobile / 36px desktop)
    function getPromoH(){
      var first = msgs[0];
      return first ? first.getBoundingClientRect().height : 36;
    }
    setInterval(function(){
      // Vague 150 P1 PERF FIX : skip si onglet caché (drain batterie inutile + reflow GBI gratuit)
      if (document.hidden) return;
      idx++;
      var h = getPromoH();
      promoTrack.style.transform = 'translateY(-' + (idx * h) + 'px)';
      if (idx === realCount) {
        // reset après l'animation (passe par le dupliqué puis snap)
        setTimeout(function(){
          promoTrack.style.transition = 'none';
          promoTrack.style.transform = 'translateY(0)';
          idx = 0;
          // restore transition
          requestAnimationFrame(function(){
            promoTrack.style.transition = '';
          });
        }, 600);
      }
    }, 4000);
  }

  // ════════════ DRAWERS : ouverture / fermeture (vague 61 a11y complet) ════════════
  // Vague 61 : focus trap + return focus + ESC + click outside (WCAG 2.4.3 + 2.1.2 + RGAA)
  var _drawerLastTrigger = null;
  var _drawerFocusTimer = 0;
  function _drawerFocusable(drawer){
    return Array.prototype.filter.call(drawer.querySelectorAll('button:not([disabled]):not([aria-disabled="true"]), [href], summary, input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'), function(el){
      if (el.tabIndex < 0 || el.disabled || el.getAttribute('aria-disabled') === 'true' || el.closest('[hidden], [inert], [aria-hidden="true"]')) return false;
      var style = window.getComputedStyle(el);
      return style.display !== 'none' && style.visibility !== 'hidden' && style.visibility !== 'collapse' && el.getClientRects().length > 0;
    });
  }
  function trapDrawerFocus(drawer, e){
    if (e.defaultPrevented || e.key !== 'Tab') return;
    var focusables = _drawerFocusable(drawer);
    if (focusables.length === 0) { e.preventDefault(); drawer.focus({ preventScroll: true }); return; }
    var first = focusables[0], last = focusables[focusables.length - 1];
    if (!drawer.contains(document.activeElement)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
    else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  var _drawerKeyHandler = null;
  // Vague 79 : helper pour sync aria-expanded sur le bouton trigger d'un drawer
  function _setTriggerExpanded(name, expanded){
    document.querySelectorAll('[data-mnl-open="' + name + '"]').forEach(function(b){
      b.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }
  function openDrawer(name){
    if (hd.dataset.open === name) { if (name === 'cart') refreshCart(); return; }
    // V1092 : exclusion mutuelle — si un AUTRE drawer est déjà ouvert (ex : menu → panier), on le ferme
    // proprement d'abord (aria-hidden/inert/aria-expanded resynchronisés + focus trap détaché) au lieu
    // d'écraser hd.dataset.open en laissant l'ancien drawer dans un état incohérent.
    if (hd.dataset.open && hd.dataset.open !== name) closeDrawer();
    _drawerLastTrigger = document.activeElement;
    hd.dataset.open = name;
    document.body.classList.add('mnl-hd-locked');
    if (name === 'cart') {
      try { document.dispatchEvent(new CustomEvent('mnl:cart:opened')); } catch(_){} // V1092 : signal global tiroir panier
      // V1106 (fondateur : « on voit deux préloaders sur le panier ») : le préloader shaker flouté plein écran
      // doublonnait avec l'état de chargement INTERNE du tiroir (« On prépare ton panier… », .mnl-hd-cart__shaker).
      // On le retire → un seul préloader, celui du tiroir (contextuel, dans le panier).
      refreshCart();
    }
    // Vague 79 : sync aria-expanded=true sur le trigger (WCAG 4.1.2 Name, Role, Value)
    _setTriggerExpanded(name, true);

    // Focus initial sur 1er élément focusable du drawer (a11y)
    var drawer = document.getElementById('mnl-hd-drawer-' + name);
    if (drawer) {
      drawer.setAttribute('aria-hidden', 'false');
      drawer.inert = false; // V930 (a11y) : drawer ouvert → interactif + exposé au lecteur d'écran
      if (name === 'search' && drawer.tagName === 'DIALOG' && !drawer.open) {
        if (typeof drawer.showModal === 'function') drawer.showModal();
        else drawer.setAttribute('open', '');
      }
      // Vague 146 : render recherches récentes à l'ouverture du search drawer
      if (name === 'search' && typeof _renderRecentSearches === 'function') {
        try { _renderRecentSearches(); } catch(_){}
      }
      if (name === 'search' && window.__mnlSearchStudio) { try { window.__mnlSearchStudio.open(); } catch(_){} }
      _drawerFocusTimer = setTimeout(function(){
        _drawerFocusTimer = 0;
        if (hd.dataset.open !== name || drawer.inert || !drawer.isConnected) return;
        var activeDialog = document.activeElement && document.activeElement.closest('[role="alertdialog"][aria-modal="true"]');
        if (activeDialog && !drawer.contains(activeDialog)) return;
        var focusables = _drawerFocusable(drawer);
        if (name === 'search') {
          var input = document.getElementById('mnl-hd-search-input');
          if (input && focusables.indexOf(input) !== -1) { input.focus({ preventScroll: true }); return; }
        }
        var firstFocus = focusables[0];
        if (firstFocus) firstFocus.focus({ preventScroll: true });
        else drawer.focus({ preventScroll: true });
      }, 350);

      // Focus trap
      _drawerKeyHandler = function(e){
        var activeAlert = document.activeElement && document.activeElement.closest('[role="alertdialog"][aria-modal="true"]');
        if (activeAlert && !drawer.contains(activeAlert)) return;
        if (!drawer.inert && hd.dataset.open === name) trapDrawerFocus(drawer, e);
      };
      document.addEventListener('keydown', _drawerKeyHandler);
    }
  }
  function closeDrawer(){
    if (_searchDebug) _searchDebug('close-enter');
    if (_drawerFocusTimer) { clearTimeout(_drawerFocusTimer); _drawerFocusTimer = 0; }
    var openName = hd.dataset.open;
    if (openName === 'search' && window.__mnlSearchStudio) { try { window.__mnlSearchStudio.close(); } catch(_){} }
    if (openName) {
      var drawer = document.getElementById('mnl-hd-drawer-' + openName);
      if (drawer) {
        if (openName === 'search' && drawer.tagName === 'DIALOG') {
          if (_searchDebug) _searchDebug('native-close-call');
          if (drawer.open && typeof drawer.close === 'function') drawer.close();
          else if (typeof drawer.showModal !== 'function') drawer.removeAttribute('open');
          if (_searchDebug) _searchDebug('native-close-after');
        }
        drawer.setAttribute('aria-hidden', 'true');
        drawer.inert = true;
      }
      // Vague 79 : sync aria-expanded=false au close
      _setTriggerExpanded(openName, false);
    }
    if (openName === 'cart') { try { document.dispatchEvent(new CustomEvent('mnl:cart:closed')); } catch(_){} } // V1092 : pendant de mnl:cart:opened
    delete hd.dataset.open;
    document.body.classList.remove('mnl-hd-locked');
    if (_drawerKeyHandler) { document.removeEventListener('keydown', _drawerKeyHandler); _drawerKeyHandler = null; }
    // Restaure le focus sur le déclencheur (WCAG 2.4.3)
    if (_drawerLastTrigger && typeof _drawerLastTrigger.focus === 'function') {
      try { _drawerLastTrigger.focus(); } catch(_){}
    }
    _drawerLastTrigger = null;
    if (_searchDebug) _searchDebug('close-exit');
  }

  // ═══ V736 : Menu déroulant compte desktop (style Nutrimuscle) — ancré sous l'avatar ═══
  // Desktop (≥981px) : clic avatar → ce dropdown (au lieu du drawer latéral). Mobile garde le drawer.
  var accWrap = document.getElementById('mnl-hd-acc');
  var accDD   = document.getElementById('mnl-hd-acc-dd');
  var accBtn  = accWrap ? accWrap.querySelector('[data-mnl-open="account"]') : null;
  var _accHideTimer = null, _accOutside = null;
  var _accRestoringFocus = false;
  function accIsDesktop(){ return window.matchMedia('(min-width: 981px)').matches; }
  function _accEsc(e){
    if (e.key !== 'Escape') return;
    e.preventDefault();
    _accHoverCancel();
    closeAccDD();
    if (accDD) accDD.hidden = true;
    if (accBtn) {
      _accRestoringFocus = true;
      try { accBtn.focus(); } catch(_){} finally { _accRestoringFocus = false; }
    }
  }
  function openAccDD(){
    if (!accWrap || !accDD) return;
    if (_accHideTimer) { clearTimeout(_accHideTimer); _accHideTimer = null; }
    if (accWrap.classList.contains('is-open')) return; // déjà ouvert → évite de ré-attacher les listeners au survol répété
    accDD.hidden = false;
    void accDD.offsetWidth; // reflow → l'animation part bien de l'état fermé
    accWrap.classList.add('is-open');
    if (accBtn) accBtn.setAttribute('aria-expanded', 'true');
    _accOutside = function(ev){ if (!accWrap.contains(ev.target)) closeAccDD(); };
    setTimeout(function(){ document.addEventListener('click', _accOutside, true); }, 0);
    document.addEventListener('keydown', _accEsc);
  }
  function closeAccDD(){
    if (!accWrap || !accDD) return;
    accWrap.classList.remove('is-open');
    if (accBtn) accBtn.setAttribute('aria-expanded', 'false');
    if (_accOutside) { document.removeEventListener('click', _accOutside, true); _accOutside = null; }
    document.removeEventListener('keydown', _accEsc);
    _accHideTimer = setTimeout(function(){ if (accWrap && !accWrap.classList.contains('is-open')) accDD.hidden = true; }, 220);
  }
  function toggleAccDD(){ if (accWrap && accWrap.classList.contains('is-open')) closeAccDD(); else openAccDD(); }
  if (accDD) {
    // Clic sur un lien (hors déconnexion qui a son propre flux de confirmation) → ferme le menu
    accDD.addEventListener('click', function(e){
      var a = e.target.closest('a');
      if (a && !a.hasAttribute('data-mnl-confirm-logout')) closeAccDD();
    });
  }
  // V741 : ouverture au survol (desktop) — demande fondateur « fait apparaitre le menu quand le client passe par dessus ».
  // Petit délai à la sortie pour pouvoir traverser l'espace icône→menu sans que ça se referme.
  var _accHoverTimer = null;
  function _accHoverCancel(){ if (_accHoverTimer) { clearTimeout(_accHoverTimer); _accHoverTimer = null; } }
  function _accHoverScheduleClose(){ _accHoverCancel(); _accHoverTimer = setTimeout(function(){ closeAccDD(); }, 200); }
  if (accWrap) {
    accWrap.addEventListener('mouseenter', function(){ if (accIsDesktop()) { _accHoverCancel(); openAccDD(); } });
    accWrap.addEventListener('mouseleave', function(){ if (accIsDesktop()) { _accHoverScheduleClose(); } });
    // Accessibilité clavier : le focus ouvre, la perte de focus hors du bloc ferme
    accWrap.addEventListener('focusin', function(){ if (!_accRestoringFocus && accIsDesktop()) { _accHoverCancel(); openAccDD(); } });
    accWrap.addEventListener('focusout', function(e){ if (accIsDesktop() && !accWrap.contains(e.relatedTarget)) { _accHoverScheduleClose(); } });
  }
  if (accDD) {
    accDD.addEventListener('mouseenter', function(){ if (accIsDesktop()) { _accHoverCancel(); } });
    accDD.addEventListener('mouseleave', function(){ if (accIsDesktop()) { _accHoverScheduleClose(); } });
  }

  // ESC global pour fermer le drawer ouvert
  document.addEventListener('keydown', function(e){
    if (e.defaultPrevented || e.key !== 'Escape' || !hd.dataset.open) return;
    var activeAlert = Array.prototype.some.call(document.querySelectorAll('[role="alertdialog"][aria-modal="true"]'), function(dialog){
      if (dialog.closest('[hidden], [inert], [aria-hidden="true"]')) return false;
      var style = window.getComputedStyle(dialog);
      if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse' || !dialog.getClientRects().length) return false;
      return dialog.classList.contains('is-open') || dialog.classList.contains('is-visible') || dialog.hasAttribute('open') || dialog.getAttribute('aria-hidden') === 'false' || dialog.contains(document.activeElement);
    });
    if (activeAlert) return;
    e.preventDefault(); closeDrawer();
  });

  function _renderRecentSearches(){
    if (window.__mnlSearchStudio) window.__mnlSearchStudio.renderRecent();
  }

  (function _searchStudio(){
    var drawer = hd.querySelector('#mnl-hd-drawer-search');
    var input = drawer && drawer.querySelector('#mnl-hd-search-input');
    var live = drawer && drawer.querySelector('#mnl-hd-search-live');
    if (!drawer || !input || !live) return;
    var form = input.form;
    var idle = drawer.querySelector('#mnl-search-idle');
    var status = drawer.querySelector('#mnl-search-status');
    var clear = drawer.querySelector('#mnl-search-clear');
    var all = drawer.querySelector('#mnl-search-all');
    var recentBox = drawer.querySelector('#mnl-hd-search-recent');
    var recentList = drawer.querySelector('#mnl-hd-search-recent-list');
    var recentClear = drawer.querySelector('#mnl-hd-search-recent-clear');
    var copyNode = hd.querySelector('#mnl-search-copy');
    var copy = {};
    try { copy = JSON.parse(copyNode ? copyNode.textContent : '{}') || {}; } catch (_) {}
    var cfg = window.__MNL_HDR_CFG || {};
    var recentKey = 'mnl-search-recent';
    var debounceTimer = 0, requestTimer = 0, controller = null, sequence = 0, composing = false;

    function message(key, values){
      var text = typeof copy[key] === 'string' ? copy[key] : '';
      return text.replace(/\{(count|query)\}/g, function(_, name){ return String(values && values[name] != null ? values[name] : ''); });
    }
    function query(){ return (input.value || '').trim(); }
    function isOpen(){ return hd.dataset.open === 'search' && !drawer.inert; }
    function cancel(){
      sequence++;
      clearTimeout(debounceTimer);
      clearTimeout(requestTimer);
      debounceTimer = 0;
      requestTimer = 0;
      if (controller) controller.abort();
      controller = null;
      live.setAttribute('aria-busy', 'false');
    }
    function recentQueries(){
      try {
        var values = JSON.parse(localStorage.getItem(recentKey) || '[]');
        if (!Array.isArray(values)) return [];
        var seen = new Set();
        return values.filter(function(value){
          if (typeof value !== 'string') return false;
          value = value.trim();
          if (value.length < 2 || value.length > 80 || seen.has(value.toLocaleLowerCase())) return false;
          seen.add(value.toLocaleLowerCase());
          return true;
        }).map(function(value){ return value.trim(); }).slice(0, 6);
      } catch (_) { return []; }
    }
    function saveRecent(value){
      value = String(value || '').trim();
      if (value.length < 2 || value.length > 80) return;
      var others = recentQueries().filter(function(item){ return item.toLocaleLowerCase() !== value.toLocaleLowerCase(); });
      try { localStorage.setItem(recentKey, JSON.stringify([value].concat(others).slice(0, 6))); } catch (_) {}
    }
    function renderRecent(){
      if (!recentBox || !recentList) return;
      var values = recentQueries();
      recentList.replaceChildren();
      values.forEach(function(value){
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'mnl-hd-search__tag ms-search-chip ms-search-chip--recent';
        button.dataset.searchQuery = value;
        button.textContent = value;
        recentList.appendChild(button);
      });
      recentBox.hidden = !values.length;
    }
    function fullSearch(value){
      var url = new URL(cfg.searchUrl || (form && form.action) || '/search', window.location.origin);
      url.searchParams.set('q', value);
      url.searchParams.set('type', 'product,article,page');
      url.searchParams.set('options[prefix]', 'last');
      return url.pathname + url.search;
    }
    function updateControls(value){
      if (clear) clear.hidden = !value;
      if (all) {
        all.hidden = value.length < 2;
        all.href = fullSearch(value);
        var label = all.querySelector('[data-search-all-label]');
        if (label) label.textContent = message('searchAll', { query: value });
        else all.textContent = message('searchAll', { query: value });
      }
    }
    function setState(state, text){
      drawer.dataset.searchState = state;
      live.hidden = state === 'idle';
      if (idle) idle.hidden = state !== 'idle';
      live.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
      if (status) status.textContent = text || '';
    }
    function feedback(text, retry){
      var panel = document.createElement('div');
      panel.className = 'ms-search-feedback';
      var line = document.createElement('p');
      line.textContent = text;
      panel.appendChild(line);
      if (retry) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'ms-search-retry';
        button.dataset.mnlSearchRetry = '';
        button.textContent = message('retry');
        panel.appendChild(button);
      }
      live.replaceChildren(panel);
    }
    function showIdle(){
      live.replaceChildren();
      setState('idle', message('idleStatus'));
      renderRecent();
    }
    function showLoading(){
      feedback(message('loading'), false);
      setState('loading', message('loading'));
    }
    function showError(){
      feedback(message('error'), true);
      setState('error', message('error'));
    }
    function validRequest(id, value){ return id === sequence && isOpen() && query() === value; }
    function spellingSuggestions(value){
      function normalize(text){ return String(text || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[-\s]/g, ''); }
      function distance(a, b){
        var rows = Array.from({ length: a.length + 1 }, function(){ return []; });
        for (var i = 0; i <= a.length; i++) rows[i][0] = i;
        for (var j = 0; j <= b.length; j++) rows[0][j] = j;
        for (var x = 1; x <= a.length; x++) for (var y = 1; y <= b.length; y++) {
          rows[x][y] = Math.min(rows[x - 1][y] + 1, rows[x][y - 1] + 1, rows[x - 1][y - 1] + (a[x - 1] === b[y - 1] ? 0 : 1));
          if (x > 1 && y > 1 && a[x - 1] === b[y - 2] && a[x - 2] === b[y - 1]) rows[x][y] = Math.min(rows[x][y], rows[x - 2][y - 2] + 1);
        }
        return rows[a.length][b.length];
      }
      var normalized = normalize(value);
      if (!/^[a-z]{5,32}$/.test(normalized)) return [];
      var terms = Array.prototype.map.call(drawer.querySelectorAll('[data-search-canonical]'), function(node){ return node.dataset.searchQuery || ''; });
      if (terms.some(function(term){ return normalize(term) === normalized; })) return [];
      var seen = new Set();
      return terms.map(function(term){ return { term: term, normalized: normalize(term) }; })
        .filter(function(item){
          if (!item.normalized || seen.has(item.normalized)) return false;
          seen.add(item.normalized);
          return Math.abs(item.normalized.length - normalized.length) <= 2;
        }).map(function(item){ return { term: item.term, score: distance(normalized, item.normalized) }; })
        .filter(function(item){ return item.score <= (normalized.length >= 8 ? 2 : 1); })
        .sort(function(a, b){ return a.score - b.score; }).slice(0, 2).map(function(item){ return item.term; });
    }
    function showSpellingSuggestions(value, count){
      var terms = spellingSuggestions(value), label = message('spelling');
      if (!terms.length && !count) {
        terms = Array.prototype.map.call(drawer.querySelectorAll('[data-search-canonical]'), function(node){ return node.dataset.searchQuery || ''; }).filter(Boolean).slice(0, 4);
        label = message('exploreTerms');
      }
      if (!terms.length || !label) return '';
      var panel = document.createElement('div');
      panel.className = 'ms-search-feedback ms-search-spelling';
      panel.setAttribute('role', 'group');
      panel.setAttribute('aria-label', label);
      var title = document.createElement('p');
      title.textContent = label;
      panel.appendChild(title);
      var choices = document.createElement('div');
      choices.className = 'mnl-hd-search__tags';
      terms.forEach(function(term){
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'mnl-hd-search__tag ms-search-chip';
        button.dataset.searchQuery = term;
        button.textContent = term;
        choices.appendChild(button);
      });
      panel.appendChild(choices);
      live.prepend(panel);
      return ' ' + label + ' ' + terms.join(', ') + '.';
    }
    function run(value){
      if (!isOpen() || value.length < 2) return;
      cancel();
      var id = sequence;
      showLoading();
      if (!window.fetch) { showError(); return; }
      controller = window.AbortController ? new AbortController() : null;
      var currentController = controller;
      var url;
      try {
        url = new URL(cfg.predictiveSearchUrl || String(cfg.searchUrl || '/search').replace(/\/$/, '') + '/suggest', window.location.origin);
        if (url.origin !== window.location.origin) throw new Error('Invalid predictive endpoint');
        url.searchParams.set('q', value);
        url.searchParams.set('section_id', 'mnl-search-predictive');
        url.searchParams.set('resources[type]', 'product,article,page');
        url.searchParams.set('resources[limit]', '4');
        url.searchParams.set('resources[limit_scope]', 'each');
        url.searchParams.set('resources[options][unavailable_products]', 'last');
      } catch (_) { showError(); return; }
      requestTimer = setTimeout(function(){
        if (!validRequest(id, value)) return;
        cancel();
        showError();
      }, 8000);
      Promise.resolve().then(function(){
        if (!validRequest(id, value)) return null;
        return fetch(url.pathname + url.search, { signal: currentController ? currentController.signal : undefined, credentials: 'same-origin', headers: { Accept: 'text/html' } });
      }).then(function(response){
        if (!validRequest(id, value)) return null;
        if (!response || !response.ok) throw new Error('Predictive search unavailable');
        return response.text();
      }).then(function(html){
        if (!validRequest(id, value)) return;
        var documentResult = new DOMParser().parseFromString(html, 'text/html');
        var marker = documentResult.querySelector('[data-mnl-predictive-results]');
        var results = marker && marker.querySelector('.ms-search-results');
        var count = marker ? Number(marker.dataset.count) : NaN;
        if (!results || !Number.isInteger(count) || count < 0) throw new Error('Invalid predictive response');
        clearTimeout(requestTimer);
        requestTimer = 0;
        controller = null;
        live.innerHTML = results.innerHTML;
        if (!count && !live.textContent.trim()) feedback(message('noResults', { query: value }), false);
        var suggestionStatus = showSpellingSuggestions(value, count);
        setState(count ? 'results' : 'empty', (count ? message('resultCount', { count: count, query: value }) : message('noResults', { query: value })) + suggestionStatus);
      }).catch(function(){
        if (!validRequest(id, value)) return;
        clearTimeout(requestTimer);
        requestTimer = 0;
        controller = null;
        showError();
      });
    }
    function update(immediate){
      cancel();
      var value = query();
      updateControls(value);
      if (!isOpen()) return;
      if (composing || value.length < 2) { showIdle(); return; }
      showLoading();
      if (immediate) run(value);
      else debounceTimer = setTimeout(function(){ debounceTimer = 0; run(value); }, 220);
    }
    input.addEventListener('input', function(event){
      if (event.isComposing) composing = true;
      update(false);
    });
    input.addEventListener('compositionstart', function(){ composing = true; update(false); });
    input.addEventListener('compositionend', function(){ composing = false; update(false); });
    input.addEventListener('search', function(){ update(false); });
    if (clear) clear.addEventListener('click', function(){ input.value = ''; update(false); input.focus({ preventScroll: true }); });
    if (form) form.addEventListener('submit', function(event){
      if (!query()) { event.preventDefault(); input.focus({ preventScroll: true }); return; }
      saveRecent(query());
      cancel();
    });
    if (recentClear) recentClear.addEventListener('click', function(){
      try { localStorage.removeItem(recentKey); } catch (_) {}
      renderRecent();
      input.focus({ preventScroll: true });
    });
    drawer.addEventListener('click', function(event){
      var target = event.target.closest('[data-search-query], [data-mnl-search-retry], [data-search-result]');
      if (!target || !drawer.contains(target)) return;
      if (target.hasAttribute('data-search-result')) { saveRecent(query()); return; }
      if (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (target.hasAttribute('data-search-query')) input.value = target.dataset.searchQuery || '';
      input.focus({ preventScroll: true });
      update(true);
    });
    drawer.addEventListener('keydown', function(event){
      if (event.defaultPrevented || event.isComposing || (event.key !== 'ArrowDown' && event.key !== 'ArrowUp')) return;
      var results = Array.prototype.slice.call(live.querySelectorAll('a[data-search-result][href], button[data-search-query]'));
      if (live.hidden || !results.length) return;
      var index = results.indexOf(document.activeElement);
      if (document.activeElement !== input && index < 0) return;
      event.preventDefault();
      var next = document.activeElement === input ? (event.key === 'ArrowDown' ? 0 : results.length - 1) : index + (event.key === 'ArrowDown' ? 1 : -1);
      (results[next] || input).focus({ preventScroll: false });
    });
    document.addEventListener('keydown', function(event){
      if (event.defaultPrevented || event.altKey || event.shiftKey || !(event.ctrlKey || event.metaKey) || String(event.key).toLowerCase() !== 'k') return;
      var coach = document.getElementById('mnl-ai-overlay');
      if (coach && coach.classList.contains('is-open')) return;
      var activeModal = document.activeElement && document.activeElement.closest('[aria-modal="true"]');
      if (activeModal && !hd.contains(activeModal)) { event.preventDefault(); event.stopImmediatePropagation(); return; }
      event.preventDefault();
      event.stopImmediatePropagation();
      if (hd.dataset.open !== 'search') openDrawer('search');
      input.focus({ preventScroll: true });
    }, true);
    window.__mnlSearchStudio = {
      open: function(){ composing = false; renderRecent(); update(true); },
      close: function(){ cancel(); },
      renderRecent: renderRecent
    };
    updateControls(query());
    showIdle();
  })();

  // V999b (fondateur) : typewriter sur la BARRE desktop (≥1360px), visible DIRECT au chargement (pas au clic). Garde le placeholder statique un instant, puis enchaîne 4 suggestions et se fige sur « Rechercher un actif, un sport… ». Respecte prefers-reduced-motion + s'arrête au clic (ouverture du tiroir).
  (function _desktopBarTypewriter(){
    var el = document.querySelector('.mnl-hd-desktop-search--xl .mnl-hd-desktop-search__input');
    if (!el) return;
    var FINAL = (el.textContent || MNL_T('header-polish.search_bar_placeholder', 'Rechercher un actif, un sport…')).trim();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || el.offsetParent === null) { el.textContent = FINAL; return; } // barre masquée (<1360px) ou reduced-motion : statique
    var seq = [FINAL, MNL_T('header-polish.search_tw_caffeine', 'Caféine'), MNL_T('header-polish.search_tw_crossfit', 'CrossFit'), MNL_T('header-polish.search_tw_creatine', 'Créatine'), MNL_T('header-polish.search_tw_no_caffeine', 'Sans caféine'), FINAL]; /* V1087 : majuscule initiale (demande fondateur) */
    var si = 0, ci = FINAL.length, deleting = true, tid = null, done = false;
    function draw(t){ el.textContent = t; }
    function tick(){
      if (done) return;
      var word = seq[si], isFinal = (si === seq.length - 1);
      if (!deleting){
        ci++; draw(word.slice(0, ci));
        if (ci >= word.length){
          if (isFinal){ done = true; return; }
          deleting = true; tid = setTimeout(tick, 1000); return;
        }
        tid = setTimeout(tick, 52 + Math.random()*38);
      } else {
        ci--; draw(word.slice(0, ci));
        if (ci <= 0){ deleting = false; si++; tid = setTimeout(tick, 220); return; }
        tid = setTimeout(tick, 25);
      }
    }
    var btn = el.closest('button');
    if (btn) btn.addEventListener('click', function(){ done = true; if (tid) clearTimeout(tid); el.textContent = FINAL; });
    draw(FINAL);
    tid = setTimeout(tick, 900);
  })();

  // Boutons d'ouverture
  document.querySelectorAll('[data-mnl-open]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      var name = btn.dataset.mnlOpen;
      // V741 : compte sur desktop → le survol ouvre le menu ; le clic mène à la page compte (style Nutrimuscle, plus naturel que de refermer le menu survolé).
      if (name === 'account' && accWrap && accDD && accIsDesktop()) {
        window.location.href = accWrap.classList.contains('mnl-hd-acc--guest') ? '/customer_authentication/login?return_to=%2Fpages%2Faccount' : '/pages/account';
        return;
      }
      // Toggle si déjà ouvert sur le même
      if (hd.dataset.open === name) closeDrawer();
      else openDrawer(name);
    });
  });

  // Vague 217 : intercept logout link (data-mnl-confirm-logout) → confirm dialog stylé puis navigate
  // Délégation pour couvrir header drawer + page-account (le link peut être rendered par 2 sections différentes)
  document.addEventListener('click', function(e){
    var logoutBtn = e.target.closest('[data-mnl-confirm-logout]');
    if (!logoutBtn) return;
    if (logoutBtn._mnlConfirmed) return; // bypass au 2e click après confirm
    e.preventDefault();
    e.stopPropagation();
    var targetUrl = logoutBtn.getAttribute('href') || '/account/logout?return_url=/';
    (window.mnlConfirm || function(o){return Promise.resolve(window.confirm(o.title));})({
      title: MNL_T('header-polish.logout_confirm_title', 'Te déconnecter ?'),
      message: MNL_T('header-polish.logout_confirm_message', 'Tu seras redirigé(e) vers la page d\'accueil.'),
      type: 'warn',
      icon: '',
      confirmText: MNL_T('header-polish.logout_confirm_ok', 'Se déconnecter'),
      cancelText: MNL_T('header-polish.logout_confirm_cancel', 'Rester connecté')
    }).then(function(ok){
      if (!ok) return;
      logoutBtn._mnlConfirmed = true;
      window.location.href = targetUrl;
    });
  });

  var searchDialog = document.getElementById('mnl-hd-drawer-search');
  if (searchDialog) {
    searchDialog.addEventListener('close', function(){
      if (searchDialog.open) return;
      searchDialog.setAttribute('aria-hidden', 'true');
      searchDialog.inert = true;
      if (!hd.dataset.open || hd.dataset.open === 'search') closeDrawer();
    });
    searchDialog.addEventListener('click', function(event){
      var button = event.target && event.target.closest ? event.target.closest('[data-mnl-search-dismiss] button[data-mnl-close]') : null;
      if (button && searchDialog.contains(button)) { if (!event.defaultPrevented) closeDrawer(); return; }
      if (typeof searchDialog.showModal !== 'function') return;
      if (event.target !== searchDialog) return;
      var rect = searchDialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDrawer();
    });
  }

  // Boutons de fermeture (overlay + croix + custom)
  function bindSearchTouchClose(button){
    var gesture = null;
    function findTouch(list, identifier){
      for (var i = 0; i < list.length; i++) if (list[i].identifier === identifier) return list[i];
      return null;
    }
    function moved(touch, start){
      return Math.abs(touch.screenX - start.x) > 16 || Math.abs(touch.screenY - start.y) > 16;
    }
    button.addEventListener('touchstart', function(event){
      gesture = null;
      if (hd.dataset.open !== 'search' || event.touches.length !== 1 || !event.cancelable) { if (_searchDebug) _searchDebug('touchstart-rejected'); return; }
      var touch = event.touches[0];
      gesture = { identifier: touch.identifier, x: touch.screenX, y: touch.screenY, drawerHandler: _drawerKeyHandler };
      event.preventDefault();
      if (_searchDebug) _searchDebug('touchstart-accepted');
    }, { passive: false });
    button.addEventListener('touchmove', function(event){
      if (!gesture) return;
      var touch = findTouch(event.touches, gesture.identifier);
      if (event.touches.length !== 1 || !touch || moved(touch, gesture)) gesture = null;
    }, { passive: true });
    button.addEventListener('touchend', function(event){
      var start = gesture;
      gesture = null;
      if (!start || event.touches.length !== 0 || hd.dataset.open !== 'search' || start.drawerHandler !== _drawerKeyHandler) { if (_searchDebug) _searchDebug('touchend-rejected-state'); return; }
      var touch = findTouch(event.changedTouches, start.identifier);
      if (!touch || moved(touch, start)) { if (_searchDebug) _searchDebug('touchend-rejected-move'); return; }
      event.preventDefault();
      event.stopPropagation();
      if (_searchDebug) _searchDebug('touchend-accepted');
      closeDrawer();
    }, { passive: false });
    button.addEventListener('touchcancel', function(){ gesture = null; }, { passive: true });
    document.addEventListener('touchstart', function(event){
      if (gesture && event.touches.length > 1) gesture = null;
    }, { passive: true, capture: true });
  }
  document.querySelectorAll('[data-mnl-close]').forEach(function(el){
    var nativeSearch = el.closest('dialog#mnl-hd-drawer-search');
    if (nativeSearch) bindSearchTouchClose(el);
    el.addEventListener('click', function(e){
      e.preventDefault();
      closeDrawer();
    });
  });
  if (_searchDebug) _searchDebug('bindings-ready');

  // Vague 107 : Escape listener déjà déclaré L2693 — doublon retiré (avant : 2 listeners trigger closeDrawer 2× = animation cassée + console errors).

  // ════════════ Vague 108 : DESKTOP NAV — ArrowLeft/Right navigation (WCAG APG menubar pattern) ════════════
  // Avant : seul Tab fonctionnait dans la nav desktop (compliant mais pas idiomatique pour un menubar).
  // Maintenant : ArrowLeft/Right cyclent entre les links de la nav active.
  document.querySelectorAll('.mnl-hd-desktop-nav, .mnl-hd-desktop-nav-secondary').forEach(function(nav){
    nav.addEventListener('keydown', function(e){
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var links = Array.prototype.slice.call(nav.querySelectorAll('.mnl-hd-desktop-nav__link'));
      if (!links.length) return;
      var idx = links.indexOf(document.activeElement);
      if (idx === -1) return;
      e.preventDefault();
      var nextIdx = e.key === 'ArrowRight' ? (idx + 1) % links.length : (idx - 1 + links.length) % links.length;
      links[nextIdx].focus();
    });
  });

  // ════════════ CART : intégration Shopify cart.js ════════════
  var formatMoney = function(cents){
    var euros = (cents / 100).toFixed(2);
    return euros.replace('.', ',') + ' €';
  };

  // Seuils livraison (en cents) — V293/V295 : aligné sur main-cart.liquid (4900/11000)
  var SHIPPING_RELAY = 4900;   // 49€ point relais offert
  var SHIPPING_HOME = 11000;   // 110€ domicile offert
  var FREE_SHIPPING_THRESHOLD = SHIPPING_HOME; // backward-compat

  // Lien Pré-Workout pour empty state + upsell
  var PREWORKOUT_URL = (window.__MNL_HDR_CFG || {}).pwUrl || '/';

  function renderBand(){
    // V676 : bandeau « Se connecter » réservé aux NON connectés (V872 : isCustomer via __MNL_HDR_CFG).
      if ((window.__MNL_HDR_CFG || {}).isCustomer) return '';
      return '<div class="mnl-hd-cart__band">' +
        '<p class="mnl-hd-cart__band-title">' + MNL_T('header-polish.cart_member_prompt', 'Déjà membre MyNutriLab ?') + '</p>' +
        '<a href="/customer_authentication/login?return_to=%2Fpages%2Faccount" class="mnl-hd-cart__band-btn">' + MNL_T('header-polish.cart_member_login', 'Se connecter') + '</a>' +
      '</div>';
  }

  function cartItemPresentation(item){
    var body = document.getElementById('mnl-hd-cart-body');
    var config = body ? body.dataset : {};
    function productHandle(url){
      var match = String(url || '').split(/[?#]/)[0].match(/\/products\/([^/]+)\/?$/);
      return match ? match[1] : '';
    }
    var expectedHandle = config.preworkoutHandle || productHandle(PREWORKOUT_URL);
    var actualHandle = item.handle || productHandle(item.url);
    var isPreworkout = !!expectedHandle && actualHandle === expectedHandle;
    return {
      isPreworkout: isPreworkout,
      title: isPreworkout ? MNL_T('header-polish.cart_preworkout_name', 'Pré-workout sur mesure') : item.product_title,
      image: (isPreworkout && config.preworkoutImage) || item.image || (item.featured_image && item.featured_image.url) || ''
    };
  }

  function renderHead(count){
    var lbl = count + MNL_T('wishlist.js_article_word', ' article') + (count > 1 ? MNL_T('wishlist.js_article_plural', 's') : '');
    // Vague 88 BUG#13 fix : avant <a href="#"> → si le delegated handler ne fire pas (race condition au render),
    // click → scroll up de la page + lecteur d'écran annonce "lien vers haut de page".
    // Maintenant : <button type="button"> = sémantique correcte + zéro effet de bord si listener absent.
    return MNL_T('header.cart_head_prefix_html', '\
      <div class="mnl-hd-cart__head">\
        <h2 class="mnl-hd-cart__title">Mon panier <span class="mnl-hd-cart__title-count">· ') + lbl + '</span></h2>\
        \
      </div>';
  }

  function renderProgress(subtotal){
    var pctHome = Math.min(100, (subtotal / SHIPPING_HOME) * 100);
    var relayReached = subtotal >= SHIPPING_RELAY;
    var homeReached = subtotal >= SHIPPING_HOME;

    // Position des markers en % de la barre (relay = 50€/110€ = ~45%, home = 100%)
    var relayMarkerPos = (SHIPPING_RELAY / SHIPPING_HOME) * 100;

    var msg;
    if (homeReached) {
      msg = MNL_T('header-polish.cart_ship_home_free_html', '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block;vertical-align:-2px;margin-right:4px" aria-hidden="true"><path d="M12 3l1.7 4.8L18.5 9.5l-4.8 1.7L12 16l-1.7-4.8L5.5 9.5l4.8-1.7z"/></svg><strong>Livraison à domicile offerte !</strong>');
    } else if (relayReached) {
      var remHome = SHIPPING_HOME - subtotal;
      msg = MNL_T('header-polish.cart_ship_home_left_prefix_html', '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block;vertical-align:-2px;margin-right:4px" aria-hidden="true"><path d="M3 11.5 12 4l9 7.5"/><path d="M5 10v9h14v-9"/><path d="M10 19v-5h4v5"/></svg>Plus que <strong>') + formatMoney(remHome) + MNL_T('header-polish.cart_ship_home_left_suffix_html', '</strong> pour la livraison <strong>à domicile offerte</strong>');
    } else {
      var remRelay = SHIPPING_RELAY - subtotal;
      msg = MNL_T('header-polish.cart_ship_relay_left_prefix_html', '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block;vertical-align:-2px;margin-right:4px" aria-hidden="true"><path d="M3 7.5 12 3l9 4.5v9L12 21 3 16.5z"/><path d="M3 7.5 12 12l9-4.5M12 12v9"/></svg>Plus que <strong>') + formatMoney(remRelay) + MNL_T('header-polish.cart_ship_relay_left_suffix_html', '</strong> pour le <strong>point relais offert</strong>');
    }

    return '\
      <div class="mnl-hd-cart__progress">\
        <p class="mnl-hd-cart__progress-txt">' + msg + '</p>\
        <div class="mnl-hd-cart__progress-bar">\
          <div class="mnl-hd-cart__progress-fill" style="width:' + pctHome + '%"></div>\
          <span class="mnl-hd-cart__progress-marker' + (relayReached ? ' is-reached' : '') + '" style="left:' + relayMarkerPos + '%"></span>\
          <span class="mnl-hd-cart__progress-marker' + (homeReached ? ' is-reached' : '') + '" style="left:100%"></span>\
        </div>\
        <div class="mnl-hd-cart__progress-thresholds">\
          <div class="' + (relayReached ? 'is-reached' : '') + '"><strong>' + formatMoney(SHIPPING_RELAY) + MNL_T('header.cart_threshold_relay_html', '</strong>Point relais</div>\
          <div class="') + (homeReached ? 'is-reached' : '') + '"><strong>' + formatMoney(SHIPPING_HOME) + MNL_T('header.cart_threshold_home_html', '</strong>Domicile</div>\
        </div>\
      </div>');
  }

  // V961+ (audit tiroir) : état du champ promo persisté à travers les re-renders — renderCart()
  // reconstruit tout le DOM, donc sans ces flags le <details> se refermait après « Appliquer »
  // et le feedback était posé sur un input devenu invisible → zéro retour utilisateur.
  var _promoOpen = false; // reflète l'état ouvert/fermé du <details> promo (maj via event toggle)
  var _promoMsg = null;   // { ok:bool, text:string } — consommé au prochain renderPromo()
  var _promoMutating = false;

  function renderPromo(appliedCode, appliedOk, promoSavings, draftValue){
    // Fondateur 2026-06-04 : cartouche « Code appliqué » HORS pliable RETIRÉ — il surgissait comme un
    // pop-up (surtout MNL10 auto-appliqué 1ʳᵉ commande).
    // V1031 (fondateur 2026-07-16 : « il faudrait pouvoir retirer le code promo ») : l'état appliqué +
    // bouton × reviennent, mais À L'INTÉRIEUR du <details> replié : fermé = discret (badge code dans le
    // summary), ouvert = code + montant + retrait en un clic. Design × carré = parité V835 (main-cart).
    var msg = _promoMsg; _promoMsg = null; // consommé : ne survit qu'au render déclenché par applyPromoCode
    var msgHTML = msg
      ? '<p class="mnl-hd-cart__promo-msg" role="status" style="margin:6px 0 0;font-size:12px;font-weight:700;color:' + (msg.ok ? '#15803d' : '#dc2626') + '">' + msg.text + '</p>'
      : '';
    var safeCode = String(appliedCode || '').replace(/[&<>"']/g, '');
    var badgeHTML = safeCode
      ? '<span style="font-size:11px;font-weight:800;color:' + (appliedOk ? '#15803d' : '#b45309') + ';white-space:nowrap;">' + safeCode + (appliedOk ? ' ✓' : ' ⚠') + '</span>'
      : '';
    var innerHTML;
    if (safeCode) {
      innerHTML = MNL_T('header.cart_promo_code_prefix_html', '\
        <div class="mnl-hd-cart__promo-applied" style="display:flex;align-items:center;justify-content:space-between;gap:10px;padding:10px 12px;background:#fff3e6;border:1.5px solid rgba(249,115,22,.45);border-radius:10px;">\
          <span style="font-size:12.5px;font-weight:700;color:#101418;line-height:1.4;">Code <strong style="color:#C2410C;letter-spacing:.04em;text-transform:uppercase;">') + safeCode + '</strong>' + (appliedOk ? '' : MNL_T('header-polish.cart_promo_not_applied_suffix', ' — non appliqué')) + MNL_T('header.cart_promo_remove_html', '</span>\
          <button type="button" class="mnl-hd-cart__promo-remove" data-mnl-promo-remove aria-label="Retirer le code promo" style="display:inline-flex;align-items:center;justify-content:center;width:38px;height:38px;min-height:38px;flex:none;padding:0;background:#101418;color:#fff;border:none;border-radius:8px;cursor:pointer;">\
            <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>\
          </button>\
        </div>');
    } else {
      // V1036 (fondateur : « retiré puis ré-appliqué, ça a bugué ») : le tiroir se reconstruit ~1s
      // après chaque opération — si le client tape pendant ce re-rendu, sa saisie était EFFACÉE
      // (input neuf vide) et son clic pouvait tomber sur un bouton détruit. On réinjecte le brouillon.
      var safeDraft = String(draftValue || '').replace(/[^A-Za-z0-9_-]/g, '').slice(0, 32);
      // V1038 (fondateur : « quand t'appliques ça ne fait rien ») : plus de <form>/submit — un <form>
      // injecté en innerHTML est SUPPRIMÉ par le parseur s'il atterrit dans un <form> ancêtre (HTML
      // imbriqué invalide) → bouton submit orphelin = clic muet, zéro erreur. Div + type=button + clic
      // + Entrée = incassable quel que soit le contexte d'injection.
      innerHTML = MNL_T('header.cart_promo_form_html', '\
        <div class="mnl-hd-cart__promo-form" data-mnl-promo-form>\
          <input type="text" class="mnl-hd-cart__promo-input" placeholder="Ton code" autocomplete="off" data-mnl-promo-input value="') + safeDraft + MNL_T('header.cart_promo_apply_html', '">\
          <button type="button" class="mnl-hd-cart__promo-btn" data-mnl-promo-apply>Appliquer</button>\
        </div>');
    }
    return '\
      <details class="mnl-hd-cart__promo"' + (_promoOpen ? ' open' : '') + MNL_T('header.cart_promo_summary_html', '>\
        <summary>\
          <span><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block;vertical-align:-2px;margin-right:4px" aria-hidden="true"><path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z"/><circle cx="7.5" cy="7.5" r="1.3"/></svg>J\'ai un code promo</span>\
          <span style="display:inline-flex;align-items:center;gap:8px;">') + badgeHTML + '<span class="mnl-hd-cart__promo-icon">▼</span></span>\
        </summary>' + innerHTML + msgHTML + '\
      </details>';
  }

  function renderEstimate(subtotal){
    var estimate;
    if (subtotal >= SHIPPING_HOME) estimate = MNL_T('header-polish.cart_estimate_free_html', '<strong>Offerte</strong>');
    else if (subtotal >= SHIPPING_RELAY) estimate = MNL_T('header-polish.cart_estimate_free_relay_html', '<strong>Offerte</strong> (point relais)');
    else estimate = MNL_T('header-polish.cart_estimate_checkout_html', '<strong>Calculée au checkout</strong>');
    return MNL_T('header.cart_estimate_lbl_html', '\
      <div class="mnl-hd-cart__estimate">\
        <span>Livraison estimée</span>\
        <span>') + estimate + '</span>\
      </div>';
  }

  var _cartPendingFocus = null;

  function captureCartUI(body){
    var state = { openKeys: [], focus: null };
    var promo = body.querySelector('.mnl-hd-cart__promo');
    if (promo) _promoOpen = promo.open;
    body.querySelectorAll('[data-cart-key]').forEach(function(row){
      var details = row.querySelector('.mnl-hd-cart__details');
      if (details && details.open) state.openKeys.push(row.dataset.cartKey);
    });
    var active = document.activeElement;
    if (active && body.contains(active) && active.dataset.cartFocus) {
      var row = active.closest('[data-cart-key]');
      state.focus = {
        key: row ? row.dataset.cartKey : '',
        control: active.dataset.cartFocus,
        start: active.selectionStart,
        end: active.selectionEnd
      };
    }
    return state;
  }

  function restoreCartUI(body, state){
    body.querySelectorAll('[data-cart-key]').forEach(function(row){
      var details = row.querySelector('.mnl-hd-cart__details');
      if (details && state.openKeys.indexOf(row.dataset.cartKey) !== -1) details.open = true;
    });
    var focus = state.focus || _cartPendingFocus;
    var active = document.activeElement;
    if (_cartMutating || _promoMutating) { _cartPendingFocus = focus; return; }
    _cartPendingFocus = null;
    if (!focus || hd.dataset.open !== 'cart' || (active && active !== document.body && !body.contains(active))) return;
    var target = null;
    Array.prototype.some.call(body.querySelectorAll('[data-cart-focus]'), function(control){
      var row = control.closest('[data-cart-key]');
      if (control.dataset.cartFocus === focus.control && (row ? row.dataset.cartKey : '') === focus.key && !control.disabled) {
        target = control; return true;
      }
      return false;
    });
    if (!target) target = body.querySelector('[data-mnl-qty]:not([disabled]), .mnl-hd-cart__empty-btn, .mnl-hd-cart__checkout');
    if (!target) return;
    target.focus({ preventScroll: true });
    if (focus.start != null && typeof target.setSelectionRange === 'function') {
      try { target.setSelectionRange(focus.start, focus.end); } catch(_){}
    }
  }

  function renderCart(cart){
    /* V934 (FIX panier qui reste « vide ») : rendre TOUJOURS dans le conteneur STABLE #mnl-hd-cart-body (jamais détruit), pas dans container.parentElement (= une .mnl-hd-cart recréée à chaque rendu → 1) IMBRICATION des .mnl-hd-cart, 2) après un rendu VIDE, #mnl-hd-cart-items disparaissait → le rendu suivant sortait sur !container → panier BLOQUÉ « vide » alors qu'il contient des items. */
    var cartBody = document.getElementById('mnl-hd-cart-body');
    if (!cartBody) return;
    var uiState = captureCartUI(cartBody);

    if (!cart.items || cart.items.length === 0) {
      cartBody.innerHTML = '\
        <div class="mnl-hd-cart">\
          ' + MNL_T('header.cart_empty_html', '\
          <div class="mnl-hd-cart__head">\
            <h2 class="mnl-hd-cart__title">Mon panier</h2>\
          </div>\
          <div class="mnl-hd-cart__items">\
            <div class="mnl-hd-cart__empty">\
              <div class="mnl-hd-cart__empty-icon"><svg width="1em" height="1em" viewBox="8 8 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><g transform="translate(8 8)" stroke-width="1.8"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></g></svg></div>\
              <h3 class="mnl-hd-cart__empty-title">Ton panier est vide</h3>\
              <p class="mnl-hd-cart__empty-sub">Configure ta formule sur-mesure et reviens.</p>\
              <a href="') + PREWORKOUT_URL + MNL_T('header.cart_empty_btn_html', '" class="mnl-hd-cart__empty-btn"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false" style="vertical-align:-2px;margin-right:6px"><line x1="4" x2="4" y1="21" y2="14"/><line x1="4" x2="4" y1="10" y2="3"/><line x1="12" x2="12" y1="21" y2="12"/><line x1="12" x2="12" y1="8" y2="3"/><line x1="20" x2="20" y1="21" y2="16"/><line x1="20" x2="20" y1="12" y2="3"/><line x1="2" x2="6" y1="14" y2="14"/><line x1="10" x2="14" y1="8" y2="8"/><line x1="18" x2="22" y1="16" y2="16"/></svg>Configurer ma formule →</a>\
            </div>\
          </div>\
        </div>');
      bindCartHandlers();
      setCartBusy(_cartMutating);
      restoreCartUI(cartBody, uiState);
      return;
    }

    // XSS escape helper (anti-injection si product titles contiennent HTML)
    function _esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' })[c]; }); }
    var itemsHTML = cart.items.map(function(item){
      var presentation = cartItemPresentation(item);
      var img = presentation.image;
      var hasCompare = item.original_line_price && item.original_line_price > item.final_line_price;
      var safeTitle = _esc(presentation.title);
      var safeProductTitle = _esc(item.product_title || presentation.title);
      var safeKey = _esc(item.key);
      var priceHTML = hasCompare
        ? '<span class="mnl-hd-cart__item-price-compare">' + formatMoney(item.original_line_price) + '</span> <span class="mnl-hd-cart__item-price-final">' + formatMoney(item.final_line_price) + '</span>'
        : formatMoney(item.final_line_price);
      // V791 (demande fondateur) : tiroir panier au MÊME STYLE + MÊMES INFOS que la page panier.
      // Port 1:1 de main-cart.liquid : pastilles oranges pour les 8 clés (Format/Sport/Saveur/Intensité/
      // Formule/Objectifs/Sans stimulants/Code promo personnalisé) + composition PLIABLE pour le reste
      // (les actifs + statut « Sans caféine »). Même liste de clés, même ORDRE de propriétés, mêmes libellés.
      var _props = item.properties || {};
      var _pv = function(k){ return _props[k] != null ? String(_props[k]) : ''; };
      // V823 (fondateur 2026-06-08) : « Objectif » (singulier, Coach IA) ajouté aux clés. RÈGLE actifs :
      // « Caféine : Sans caféine » (0 mg) = ligne de composition mais PAS un actif → affichée mais NON
      // comptée (le compteur « N actifs » = uniquement les dosés). Aligne le tiroir sur la page panier /
      // récap configurateur / checkout (tous comptent dose > 0).
      var _KEY = {'Format':1,'Sport':1,'Saveur':1,'Intensité':1,'Formule':1,'Étiquette':1,'Objectif':1,'Objectifs':1,'Sans stimulants':1,'Code promo personnalisé':1};
      var _pillsArr = [], _doseRows = [], _infoRows = [];
      Object.keys(_props).forEach(function(k){
        if (!k || k.indexOf('_') !== -1 || !_pv(k)) return; // skip props internes (_*) + vides — comme `unless pname contains '_'`
        if (_KEY[k]) _pillsArr.push('<span class="mnl-hd-cart__prop-pill">' + _esc(k) + ': <strong>' + _esc(_pv(k)) + '</strong></span>');
        else if (_pv(k) === 'Sans caféine' || _pv(k) === 'Exclue — déjà consommée à part') _infoRows.push('<div class="mnl-hd-cart__details-row mnl-hd-cart__details-row--info"><span>' + _esc(k) + '</span><strong>' + _esc(_pv(k)) + '</strong></div>');
        else _doseRows.push('<div class="mnl-hd-cart__details-row"><span>' + _esc(k) + '</span><strong>' + _esc(_pv(k)) + '</strong></div>');
      });
      var formulaMetaHTML = _pillsArr.length ? '<div class="mnl-hd-cart__props-key">' + _pillsArr.join('') + '</div>' : '';
      var _compoRows = _doseRows.concat(_infoRows);
      var compoHTML = _compoRows.length ? MNL_T('header-polish.cart_compo_summary_prefix_html', '<details class="mnl-hd-cart__details"><summary>Voir composition (') + _doseRows.length + MNL_T('header-polish.cart_compo_summary_suffix_html', ' actifs)</summary><div class="mnl-hd-cart__details-list">') + _compoRows.join('') + '</div></details>' : '';
      // #5 (fondateur) : libellé clair d'abonnement quand la ligne porte un selling plan (avant : le panier ne montrait que le prix).
      var _sub = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
      var subHTML = _sub ? MNL_T('header-polish.cart_item_subscription_html', '<p class="mnl-hd-cart__item-sub">Abonnement mensuel · livraison tous les 30 jours</p>') : '';
      return '\
        <div class="mnl-hd-cart__item' + (presentation.isPreworkout ? ' mnl-hd-cart__item--preworkout' : '') + '" data-cart-key="' + safeKey + '" data-product-name="' + safeProductTitle + '">\
          ' + (img ? '<img src="' + _esc(img) + '" alt="' + safeProductTitle + '" class="mnl-hd-cart__item-img" loading="lazy" decoding="async" width="80" height="80">' : '<div class="mnl-hd-cart__item-img"></div>') + '\
          <div class="mnl-hd-cart__item-info">\
            <h4 class="mnl-hd-cart__item-name">' + safeTitle + '</h4>\
            ' + (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="mnl-hd-cart__item-variant">' + _esc(item.variant_title) + '</p>' : '') + '\
            ' + formulaMetaHTML + subHTML + compoHTML + '\
            <div class="mnl-hd-cart__item-controls">\
              <div class="mnl-hd-cart__item-qty">\
                <button type="button" data-mnl-qty="-1" data-key="' + safeKey + MNL_T('header.cart_qty_minus_html', '" aria-label="Diminuer">−</button>\
                <span>') + parseInt(item.quantity, 10) + '</span>\
                <button type="button" data-mnl-qty="+1" data-key="' + safeKey + MNL_T('header.cart_qty_plus_html', '" aria-label="Augmenter">+</button>\
              </div>\
              <div class="mnl-hd-cart__item-price">') + priceHTML + '\
              </div><button type="button" class="mnl-hd-cart__item-remove" data-mnl-remove="' + safeKey + MNL_T('header-polish.cart_item_remove_aria_html', '" aria-label="Retirer ') + safeProductTitle + MNL_T('header.cart_item_remove_html', '">Retirer</button>\
            </div>\
          </div>\
          ') + '\
        </div>';
    }).join('');

    var subtotal = cart.total_price;
    // V1031 : discount_codes d'abord — la réponse /cart/update.js omet parfois title/total_allocated_amount
    // sur cart_level_discount_applications (vérifié live), et applicable:false = code posé mais conditions
    // non remplies → chip ambre + retrait possible (sinon code fantôme qu'on ne peut plus enlever).
    var _dcFirst = null;
    (cart.discount_codes || []).some(function(d){ if (d && d.code) { _dcFirst = d; return true; } return false; });
    var appliedCode = _dcFirst ? _dcFirst.code
      : ((cart.cart_level_discount_applications && cart.cart_level_discount_applications[0]) ? (cart.cart_level_discount_applications[0].title || '') : '');
    var appliedOk = _dcFirst ? _dcFirst.applicable !== false : !!appliedCode;
    var promoSavings = 0;
    try { promoSavings = (cart.cart_level_discount_applications || []).reduce(function(s, a){ return s + ((a && a.total_allocated_amount) || 0); }, 0); } catch(_){}
    var totalDiscount = cart.total_discount || 0;
    // V961+ FIX : n'auto-applique MNL10 au checkout QUE si AUCUN code n'est déjà posé — Shopify ne
    // garde qu'UN code : /discount/MNL10 écraserait le code déjà appliqué par le client.
    // cart_level_discount_applications = codes niveau panier (présent dans /cart.js, /cart/change.js,
    // /cart/update.js — déjà utilisé plus haut pour appliedCode) ; discount_codes (si exposé) couvre
    // aussi les codes niveau ligne / non encore applicables.
    /* V980 : discount_codes peut contenir des codes NON applicables (posés mais conditions non
       remplies) — on ne compte que les codes réellement applicables, sinon un code inerte
       bloquait l'auto-apply MNL10. */
    var hasPromoApplied = (cart.cart_level_discount_applications || []).length > 0
      || (cart.discount_codes || []).some(function(d){ return d && d.applicable !== false; });
    // V1031 : retrait EXPLICITE d'un code par le client (bouton ×) → on ne ré-auto-applique pas MNL10
    // au checkout ni ne ré-affiche le teaser pendant la session (sinon « Retirer » a l'air cassé — le
    // code reviendrait tout seul). Ré-appliquer un code, ou nouvelle session, ré-active la promesse V961.
    var promoOptOut = false;
    try { promoOptOut = sessionStorage.getItem('mnl-promo-optout') === '1'; } catch(_){}

    // V998 (audit #5) : rappel MNL10 dans le tiroir panier — parcours majoritaire (configurateur/Coach) voyait le prix plein juste avant « Paiement ». Mêmes conditions EXACTES que le href checkout (l.978).
    var mnl10Line = '';
    /* V1212 (fondateur) : « barre le prix et mets −10 € quand tu sais que c'est sa 1ʳᵉ commande ».
       window.mnlFirstOrderEligible() vient de theme.liquid (rendu par requête) — jamais d'info client
       écrite dans ce fichier, qui est un asset mis en cache CDN et servi tel quel à tout le monde.
       Client connecté ayant déjà commandé → ni barré ni promesse de −10 € : il n'y a plus droit. */
    var _firstOrderOk = true;
    try { if (typeof window.mnlFirstOrderEligible === 'function') _firstOrderOk = window.mnlFirstOrderEligible(); } catch(_){}
    /* V1214 (fondateur 31/07/2026 : « tu n'as pas appliqué les −10 € sur le mode abonnement »).
       MNL10 accepte DÉSORMAIS l'abonnement — posé via discountCodeBasicUpdate le 31/07/2026,
       userErrors vide, vérifié : −10 € fixes, sous-total ≥ 39 €, appliesOncePerCustomer = true,
       segment « aucune commande », appliesOnOneTimePurchase = TRUE **et** appliesOnSubscription =
       TRUE (c'est ce dernier qui a changé), recurringCycleLimit = 1.
       Conséquence : en abonnement la remise ne tombe QUE sur la PREMIÈRE LIVRAISON ; les livraisons
       suivantes gardent le −10 % du plan, SANS les −10 €. Sur cette première livraison les deux
       remises se CUMULENT (−10 % puis −10 €).
       Le garde « && !_hasSub » est donc SUPPRIMÉ : il privait un abonné éligible de la remise et
       renvoyait le bouton « Paiement » vers /checkout au lieu de /discount/MNL10.
       _hasSub est CONSERVÉ mais ne bloque plus rien — il choisit seulement le LIBELLÉ. Écrire
       « 1re commande » en mode abonnement ferait comprendre −10 € à CHAQUE prélèvement. */
    var _hasSub = false;
    try { _hasSub = (cart.items || []).some(function(i){ return i && i.selling_plan_allocation; }); } catch(_){}
    var _mnl10Ok = _firstOrderOk;
    var _mnl10Occ = _hasSub ? MNL_T('header-polish.cart_mnl10_first_delivery_html', '1<sup>re</sup> livraison seulement') : MNL_T('header-polish.cart_mnl10_first_order_html', '1<sup>re</sup> commande');
    var _mnl10SubNote = _hasSub ? MNL_T('header-polish.cart_mnl10_sub_note_html', '<br><span style="font-weight:400;opacity:.85;">Les livraisons suivantes gardent le −10 % de l\'abonnement.</span>') : '';
    if (!hasPromoApplied && !promoOptOut && _mnl10Ok) {
      // Échelle à deux seuils RÉELS : 39 € (MNL10 −10 €) puis 49 € (point relais offert — même
      // seuil SHIPPING_RELAY que renderProgress/renderEstimate). Fine barre de progression vers
      // le prochain seuil (spans inline : un <div> dans <p> serait recassé par le parseur innerHTML).
      /* V1212b : les deux seuils ne se lisent PAS sur la même base. Le minimum de MNL10 (39 €) porte sur
         le sous-total AVANT remise ; le port relais offert (49 €) est une condition TOTAL_PRICE que
         Shopify évalue APRÈS remise. Un panier à 49 € cochait donc les deux cases ici alors qu'une fois
         les −10 € posés il retombe à 39 € et le relais redevient payant. Il faut 59 € pour cumuler. */
      var _apresRemise = subtotal >= 3900 ? (subtotal - 1000) : subtotal;
      var _ladderNext = subtotal >= 3900 ? SHIPPING_RELAY : 3900;
      var _ladderVal = subtotal >= 3900 ? _apresRemise : subtotal;
      var _ladderBar = '<span style="display:block;height:3px;margin-top:5px;border-radius:2px;background:rgba(0,0,0,.08);overflow:hidden;"><span style="display:block;height:100%;width:' + Math.min(100, Math.round((_ladderVal / _ladderNext) * 100)) + '%;background:#E84E1B;border-radius:2px;"></span></span>';
      if (_apresRemise >= SHIPPING_RELAY && subtotal >= 3900) {
        mnl10Line = MNL_T('header-polish.cart_mnl10_ok_relay_prefix_html', '<p class="mnl-hd-cart__mnl10" style="margin:6px 0 10px;font:600 12.5px/1.45 \'Manrope\',ui-sans-serif,sans-serif;color:#1a1a1a;"><span style="color:#15803d;font-weight:800;">✓</span> <strong style="color:#E84E1B;white-space:nowrap;">−10 €</strong> <strong>MNL10</strong> appliqué au paiement (') + _mnl10Occ + MNL_T('header-polish.cart_mnl10_ok_relay_suffix_html', ') · <span style="color:#15803d;font-weight:800;">✓</span> livraison <strong>relais offerte</strong>') + _mnl10SubNote + '</p>';
      } else if (subtotal >= 3900) {
        mnl10Line = MNL_T('header-polish.cart_mnl10_ok_prefix_html', '<p class="mnl-hd-cart__mnl10" style="margin:6px 0 10px;font:600 12.5px/1.45 \'Manrope\',ui-sans-serif,sans-serif;color:#1a1a1a;"><span style="color:#15803d;font-weight:800;">✓</span> <strong>MNL10</strong> appliqué au paiement (') + _mnl10Occ + MNL_T('header-polish.cart_mnl10_ok_mid_html', ') · plus que <strong style="color:#E84E1B;">') + formatMoney(SHIPPING_RELAY - _apresRemise) + MNL_T('header-polish.cart_mnl10_ok_suffix_html', '</strong> pour la livraison <strong>relais offerte</strong>') + _mnl10SubNote + _ladderBar + '</p>';
      } else if (subtotal >= 2900) {
        mnl10Line = MNL_T('header-polish.cart_mnl10_teaser_prefix_html', '<p class="mnl-hd-cart__mnl10" style="margin:6px 0 10px;font:600 12.5px/1.45 \'Manrope\',ui-sans-serif,sans-serif;color:#1a1a1a;">Plus que <strong style="color:#E84E1B;">') + formatMoney(3900 - subtotal) + MNL_T('header-polish.cart_mnl10_teaser_suffix_html', '</strong> pour −10 € avec le code <strong>MNL10</strong> (') + _mnl10Occ + ').' + _mnl10SubNote + _ladderBar + '</p>';
      }
    }

    /* V1212 : le sous-total du tiroir montre lui aussi le prix APRÈS MNL10 — c'est le dernier chiffre
       que voit le client avant de cliquer « Paiement », et le code y est déjà auto-appliqué par le href.
       Mêmes conditions que mnl10Line : éligible, ≥ 39 €, aucun autre code posé, pas de retrait explicite. */
    var _mnl10Strike = _mnl10Ok && !hasPromoApplied && !promoOptOut && subtotal >= 3900;
    var _mnl10SubtotalHtml = _mnl10Strike
      ? '<s style="opacity:.55;font-weight:600;font-size:.68em;margin-right:6px;">' + formatMoney(subtotal) + '</s>' + formatMoney(subtotal - 1000)
      : formatMoney(subtotal);

    /* V1212b : les seuils de port (relais 49 €, domicile 110 €) sont des conditions TOTAL_PRICE évaluées
       par Shopify APRÈS remise — vérifié dans le profil de livraison via l'API Admin. La barre de
       progression et l'estimation doivent donc raisonner sur le montant réellement payé, sinon le tiroir
       annonce « relais offert » sur un panier qui, une fois les −10 € posés, repasse sous les 49 €. */
    var subtotalLivraison = _mnl10Strike ? (subtotal - 1000) : subtotal;

    // V1036 : préserve la saisie promo en cours à travers le re-rendu (sinon effacée — cause du
    // « retiré puis ré-appliqué, ça a bugué » fondateur 2026-07-16).
    var promoDraft = '';
    try { var _dEl = cartBody.querySelector('[data-mnl-promo-input]'); if (_dEl) promoDraft = _dEl.value || ''; } catch(_){}

    cartBody.innerHTML = '\
      <div class="mnl-hd-cart">\
        ' + renderHead(cart.item_count) + '\
        ' + renderBand() + '\
        ' + renderProgress(subtotalLivraison) + '\
        <div class="mnl-hd-cart__items" id="mnl-hd-cart-items">' + itemsHTML + '\
        </div>\
        ' + renderPromo(appliedCode, appliedOk, promoSavings, promoDraft) + '\
        ' + renderEstimate(subtotalLivraison) + '\
        <div class="mnl-hd-cart__footer">\
          ' + (totalDiscount > 0 ? MNL_T('header-polish.cart_discount_line_html', '<div class="mnl-hd-cart__discount-line"><span>Réduction</span><span>−') + formatMoney(totalDiscount) + '</span></div>' : '') + MNL_T('header.cart_total_html', '\
          <div class="mnl-hd-cart__total">\
            <div>\
              <span class="mnl-hd-cart__total-lbl">Sous-total</span>\
              <p class="mnl-hd-cart__total-sub">Taxes incluses · livraison au checkout</p>\
            </div>\
            <span class="mnl-hd-cart__total-val">') + _mnl10SubtotalHtml + '</span>\
          </div>\
          ' + mnl10Line + MNL_T('header.cart_relaynote_html', '\
          <p class="mnl-hd-cart__relaynote" style="margin:2px 0 8px;font:600 11.5px/1.45 \'Manrope\',ui-sans-serif,sans-serif;color:#5f5e5a;display:flex;align-items:flex-start;gap:6px;">\
            <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex:0 0 auto;margin-top:1px" aria-hidden="true"><path d="M12 21s-7-6.3-7-11a7 7 0 0 1 14 0c0 4.7-7 11-7 11z"/><circle cx="12" cy="10" r="2.5"/></svg>\
            <span>Point relais&nbsp;? Tu choisiras ton point de retrait Mondial&nbsp;Relay juste après le paiement.</span>\
          </p>\
          <a href="') + (_mnl10Ok && subtotal >= 3900 && !hasPromoApplied && !promoOptOut ? '/discount/MNL10?redirect=/checkout' : '/checkout') + MNL_T('header.cart_checkout_html', '" class="mnl-hd-cart__checkout"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block;vertical-align:-2px;margin-right:4px" aria-hidden="true"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>Paiement sécurisé →</a>\
          <a href="/cart" class="mnl-hd-cart__continue">Voir mon panier</a>\
        </div>\
      </div>');

    // Re-bind handlers
    bindCartHandlers();
    setCartBusy(_cartMutating);
    restoreCartUI(cartBody, uiState);
  }

  function bindCartHandlers(){
    // V985c : scope au tiroir panier (#mnl-hd-cart-body). Avant, document.querySelectorAll
    // attrapait aussi les boutons de main-cart.liquid sur /cart (mêmes attributs data-mnl-qty /
    // data-mnl-remove) → TypeError (parent sans <span>) + double POST /cart/change.js concurrent.
    var body = document.getElementById('mnl-hd-cart-body');
    if (!body) return;
    body.querySelectorAll('[data-mnl-qty]').forEach(function(btn){
      var row = btn.closest('.mnl-hd-cart__item');
      var productName = row && row.dataset.productName;
      btn.dataset.cartFocus = 'quantity-' + btn.dataset.mnlQty;
      if (productName) btn.setAttribute('aria-label', (btn.getAttribute('aria-label') || '') + ' — ' + productName);
      btn.addEventListener('click', function(){
        var key = btn.dataset.key;
        var delta = parseInt(btn.dataset.mnlQty);
        var qtyEl = btn.parentElement.querySelector('span');
        if (!qtyEl) return; // V985c : garde — parent sans <span> (input de la page panier)
        var newQty = parseInt(qtyEl.textContent) + delta;
        if (newQty < 0) return;
        updateCart(key, newQty);
      });
    });
    body.querySelectorAll('[data-mnl-remove]').forEach(function(btn){
      btn.dataset.cartFocus = 'remove';
      btn.addEventListener('click', function(){
        updateCart(btn.dataset.mnlRemove, 0);
      });
    });
    [
      ['.mnl-hd-cart__details > summary', 'composition'],
      ['.mnl-hd-cart__promo > summary', 'promo-summary'],
      ['[data-mnl-promo-input]', 'promo-input'],
      ['[data-mnl-promo-apply]', 'promo-apply'],
      ['[data-mnl-promo-remove]', 'promo-remove'],
      ['.mnl-hd-cart__checkout', 'checkout'],
      ['.mnl-hd-cart__continue', 'continue']
    ].forEach(function(entry){ body.querySelectorAll(entry[0]).forEach(function(control){ control.dataset.cartFocus = entry[1]; }); });
    // V985c : bloc [data-mnl-close] retiré. Ces éléments statiques sont HORS #mnl-hd-cart-body
    // et déjà bindés une seule fois au boot (l.692) ; le re-bind à chaque render empilait des
    // listeners sans borne (fuite mémoire + closeDrawer exécuté N fois par clic).
    // V961+ : persiste l'état ouvert/fermé du <details> promo à travers les re-renders
    var promoDetails = body.querySelector('.mnl-hd-cart__promo');
    if (promoDetails) {
      promoDetails.addEventListener('toggle', function(){ _promoOpen = promoDetails.open; });
    }
    // Promo code — V1040 : DÉLÉGATION une-fois sur le conteneur STABLE #mnl-hd-cart-body (jamais
    // détruit, V934). Les bindings par-render (V1038) pouvaient laisser un bouton VISIBLE sans
    // listener selon l'ordre des rendus (clic muet sans erreur — fondateur ×3, intermittent). La
    // délégation survit à tous les re-renders : le clic remonte au conteneur, on résout la cible
    // AU MOMENT du clic. Enter sur l'input = même chemin.
    if (!body._mnlPromoDelegated) {
      body._mnlPromoDelegated = true;
      body.addEventListener('click', function(e){
        var t = e.target;
        if (!t || !t.closest) return;
        var applyBtn = t.closest('[data-mnl-promo-apply]');
        if (applyBtn) {
          if (_promoMutating || _cartMutating || _cartNeedsReview) return;
          var wrap = applyBtn.closest('[data-mnl-promo-form]');
          var input = wrap ? wrap.querySelector('[data-mnl-promo-input]') : null;
          var code = (input && input.value || '').trim().toUpperCase();
          if (code) { applyPromoCode(code, wrap); return; }
          // V1041 (LA cause du « ça ne fait rien » fondateur) : le placeholder « MNL10 » ressemblait
          // à un code déjà saisi → clic sur Appliquer avec champ VIDE → retour silencieux. Désormais :
          // placeholder neutre + message explicite + focus (jamais de clic muet).
          if (input) input.focus();
          var d = wrap ? wrap.parentElement : null;
          if (d) {
            var m = d.querySelector('.mnl-hd-cart__promo-msg');
            if (!m) {
              m = document.createElement('p');
              m.className = 'mnl-hd-cart__promo-msg';
              m.setAttribute('role', 'status');
              m.style.cssText = 'margin:6px 0 0;font-size:12px;font-weight:700;color:#dc2626';
              d.appendChild(m);
            }
            m.textContent = MNL_T('header-polish.cart_promo_empty_hint', 'Tape ton code (ex : MNL10) puis Appliquer');
          }
          return;
        }
        var rm = t.closest('[data-mnl-promo-remove]');
        if (rm) {
          if (_promoMutating || _cartMutating || _cartNeedsReview) return;
          _cartPendingFocus = captureCartUI(body).focus;
          applyPromoCode('', null);
        }
      });
      body.addEventListener('keydown', function(e){
        if (e.key !== 'Enter' || !e.target || !e.target.closest) return;
        var input = e.target.closest('[data-mnl-promo-input]');
        if (!input) return;
        e.preventDefault();
        var wrap = input.closest('[data-mnl-promo-form]');
        var code = (input.value || '').trim().toUpperCase();
        if (code) applyPromoCode(code, wrap);
      });
    }
  }

  function applyPromoCode(code, formEl){
    if (_promoMutating || _cartMutating || _cartNeedsReview) return;
    _promoMutating = true;
    _cartError = '';
    // V961+ : aligné sur main-cart.liquid (Vague 66) — POST /cart/update.js { discount } applique ET
    // permet de VÉRIFIER l'application via cart.discount_codes, au lieu de l'ancien GET /discount/<code>
    // aveugle. Le feedback est posé via _promoOpen/_promoMsg AVANT renderCart (le re-render détruisait
    // l'ancien message et refermait le <details> → aucun retour visible).
    // V1031 : timeout 15s (parité main-cart V408 — sans lui, un réseau mobile qui ne répond jamais
    // laissait le bouton sur « ... » à vie, fondateur 2026-07-16) + re-fetch /cart.js CANONIQUE après
    // application (la réponse /cart/update.js omet title/total_allocated_amount → chip incomplet)
    // + gestion du retrait (code vide = enlever le code + opt-out session de l'auto-apply MNL10).
    var body = document.getElementById('mnl-hd-cart-body');
    if (body) _cartPendingFocus = captureCartUI(body).focus || _cartPendingFocus;
    var btn = formEl ? formEl.querySelector('.mnl-hd-cart__promo-btn') : null;
    if (btn) { btn.disabled = true; btn.textContent = '...'; }
    setCartBusy(true);
    function refreshAfterPromo(){
      return refreshCart(function(){ _promoMutating = false; }).then(function(fullCart){
        _promoMutating = false;
        if (fullCart) updateCartBadge(fullCart.item_count);
        else _cartError = MNL_T('header-polish.cart_promo_network_error', 'Erreur réseau — réessaie');
        if (btn) { btn.disabled = false; btn.textContent = MNL_T('header-polish.cart_promo_apply', 'Appliquer'); }
        setCartBusy(false);
        return fullCart;
      });
    }
    var ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    var timeoutId = setTimeout(function(){ if (ctrl) ctrl.abort(); }, 15000);
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: code }),
      signal: ctrl ? ctrl.signal : undefined
    })
      .then(function(r){ clearTimeout(timeoutId); if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function(cart){
        var applied = Array.isArray(cart.discount_codes)
          && cart.discount_codes.some(function(d){ return d && d.code === code && d.applicable !== false; });
        // Filet si discount_codes absent de la réponse : un code panier appliqué apparaît dans
        // cart_level_discount_applications (titre = code).
        if (!applied && (cart.cart_level_discount_applications || []).some(function(d){ return d && String(d.title || '').toUpperCase() === code; })) applied = true;
        _promoOpen = true; // garde le <details> ouvert pour montrer le feedback après re-render
        if (code) {
          _promoMsg = applied ? { ok: true, text: MNL_T('header-polish.cart_promo_ok', 'Code appliqué ✓') } : { ok: false, text: MNL_T('header-polish.cart_promo_ko', 'Code non appliqué : vérifie le code ou le minimum d\'achat.') }; /* V1117 FIX F6 : le motif exact (code erroné vs minimum non atteint) n\'est pas fiable côté client → message unique, honnête et actionnable, cohérent avec la puce « non appliqué ». Avant : « Code invalide » (toast) + « minimum d\'achat non atteint » (puce) = 2 messages contradictoires. */
          if (applied) { try { sessionStorage.removeItem('mnl-promo-optout'); } catch(_){} } // ré-appliquer = ré-opt-in auto-apply
        } else {
          _promoMsg = { ok: true, text: MNL_T('header-polish.cart_promo_removed', 'Code retiré') };
          try { sessionStorage.removeItem('mnl-promo-code'); sessionStorage.setItem('mnl-promo-optout', '1'); } catch(_){}
        }
        // Re-render depuis /cart.js canonique (title + montants complets), pas la réponse update.js maigre
        return refreshAfterPromo();
      })
      .catch(function(err){
        clearTimeout(timeoutId);
        console.error('[MNL Header] Promo error:', err);
        var isTimeout = err && err.name === 'AbortError';
        _promoOpen = true;
        _promoMsg = { ok: false, text: isTimeout ? MNL_T('header-polish.cart_promo_timeout', 'Délai dépassé — vérifie ta connexion') : MNL_T('header-polish.cart_promo_network_error', 'Erreur réseau — réessaie') };
        refreshAfterPromo();
      });
  }

  function refreshCart(beforeRender){
    // V985c : retourne la promesse (avec le cart) pour que le listener mnl:cart:updated réutilise
    // ce fetch au lieu d'en lancer un 2e pour le badge. Les autres appelants ignorent le retour.
    return Promise.resolve().then(function(){
      if (window.MNL_CART && typeof window.MNL_CART.read === 'function') return window.MNL_CART.read();
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r){
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      });
    })
      .then(function(cart){
        if (!cart || !Array.isArray(cart.items)) throw new Error('Invalid cart');
        if (typeof beforeRender === 'function') beforeRender();
        if (!_cartMutating && window.MNL_CART && window.MNL_CART.hasPending()) {
          _cartNeedsReview = true;
          _cartError = MNL_T('cart.js_uncertain', 'La mise à jour reste incertaine. Vérifie le panier avant de poursuivre : aucune nouvelle modification ne sera envoyée.');
        }
        renderCart(cart); return cart;
      })
      .catch(function(err){ console.error('[MNL Header] Cart fetch error:', err); });
  }

  var _cartMutating = false; // V821 : verrou anti-race sur les mutations panier
  var _cartError = '';
  var _cartNeedsReview = false;

  function setCartBusy(busy){
    busy = !!busy || _promoMutating;
    var body = document.getElementById('mnl-hd-cart-body');
    if (!body) return;
    body.setAttribute('aria-busy', busy ? 'true' : 'false');
    body.classList.toggle('is-updating', !!busy);
    body.querySelectorAll('[data-mnl-qty], [data-mnl-remove], [data-mnl-promo-apply], [data-mnl-promo-remove]').forEach(function(button){ button.disabled = !!busy || _cartNeedsReview; });
    var checkout = body.querySelector('.mnl-hd-cart__checkout');
    if (checkout) {
      if (busy || _cartNeedsReview) checkout.setAttribute('aria-disabled', 'true');
      else checkout.removeAttribute('aria-disabled');
    }
    var message = busy ? MNL_T('header-polish.cart_updating', 'Mise à jour du panier…') : _cartError;
    var status = body.querySelector('.mnl-hd-cart__status');
    var head = body.querySelector('.mnl-hd-cart__head');
    if (!status && message && head) {
      status = document.createElement('p');
      status.className = 'mnl-hd-cart__status';
      head.insertAdjacentElement('afterend', status);
    }
    if (status) {
      status.hidden = !message;
      status.textContent = message || '';
      status.setAttribute('role', _cartError && !busy ? 'alert' : 'status');
      status.classList.toggle('is-error', !!_cartError && !busy);
      if (_cartNeedsReview && !busy) {
        var verify = document.createElement('button');
        verify.type = 'button';
        verify.className = 'mnl-hd-cart__verify';
        verify.textContent = MNL_T('cart.js_verify', 'Vérifier le panier');
        verify.addEventListener('click', recoverCart);
        status.appendChild(verify);
      }
    }
  }

  function finishCartUpdate(cart){
    _cartMutating = false;
    _cartNeedsReview = false;
    _cartError = '';
    renderCart(cart);
    updateCartBadge(cart.item_count);
    try { document.dispatchEvent(new CustomEvent('mnl:cart:updated', { detail: { count: cart.item_count, source: 'drawer' } })); } catch(_) {}
  }

  function failCartUpdate(err){
    console.error('[MNL Header] Cart update error:', err);
    _cartMutating = false;
    _cartNeedsReview = !!(err && err.uncertain) || !!(window.MNL_CART && window.MNL_CART.hasPending());
    _cartError = _cartNeedsReview
      ? MNL_T('cart.js_uncertain', 'La mise à jour reste incertaine. Vérifie le panier avant de poursuivre : aucune nouvelle modification ne sera envoyée.')
      : MNL_T('header-polish.cart_update_error', 'Impossible de modifier le panier. Réessaie.');
    setCartBusy(false);
    if (err && err.cart) { renderCart(err.cart); updateCartBadge(err.cart.item_count); }
    else refreshCart();
  }

  function recoverCart(){
    if (_cartMutating) return;
    _cartMutating = true;
    setCartBusy(true);
    Promise.resolve().then(function(){
      if (!window.MNL_CART) throw new Error('Cart safety helper unavailable');
      return window.MNL_CART.recover();
    }).then(function(){ return window.MNL_CART.read(); }).then(finishCartUpdate).catch(failCartUpdate);
  }

  function updateCart(key, qty){
    if (_cartMutating || _promoMutating || _cartNeedsReview) return;
    var body = document.getElementById('mnl-hd-cart-body');
    _cartPendingFocus = body ? captureCartUI(body).focus : null;
    _cartMutating = true;
    _cartError = '';
    setCartBusy(true);
    Promise.resolve().then(function(){
      if (!window.MNL_CART || typeof window.MNL_CART.change !== 'function') throw new Error('Cart safety helper unavailable');
      return window.MNL_CART.change(key, qty);
    }).then(finishCartUpdate).catch(failCartUpdate);
  }

  function updateCartBadge(count){
    var badge = document.getElementById('mnl-hd-cart-count');
    var btn = document.getElementById('mnl-hd-cart-btn');
    if (!badge) return;
    badge.textContent = count;
    badge.style.display = count > 0 ? 'inline-flex' : 'none';
    if (btn) {
      btn.classList.add('is-pulse');
      setTimeout(function(){ btn.classList.remove('is-pulse'); }, 600);
    }
    if (btn) btn.setAttribute('aria-label', MNL_T('header.cart_aria_prefix', 'Mon panier (') + count + MNL_T('wishlist.js_article_word', ' article') + (count > 1 ? MNL_T('wishlist.js_article_plural', 's') : '') + ')');
  }

  // ════════════ ATC : auto-open cart drawer & refresh ════════════
  var genericATCState = new WeakMap();

  function genericATCPayload(formData){
    var fields = {}, item = { quantity: 1, properties: {} }, payload = { items: [item] }, supported = true;
    formData.forEach(function(value, name){
      if (typeof value !== 'string') {
        if (value && value.size === 0 && !value.name) return;
        supported = false;
        return;
      }
      if (Object.prototype.hasOwnProperty.call(fields, name)) { supported = false; return; }
      fields[name] = value;
      var property = /^properties\[([^\]]+)\]$/.exec(name);
      if (property) item.properties[property[1]] = value;
      else if (name === 'id') item.id = value;
      else if (name === 'quantity') item.quantity = Number(value);
      else if (name === 'selling_plan') { if (value) item.selling_plan = value; }
      else if (name === 'sections' || name === 'sections_url') { if (value) payload[name] = value; }
      else if (name !== 'form_type' && name !== 'utf8') supported = false;
    });
    if (!supported || !/^[1-9]\d*$/.test(String(item.id || '')) || !Number.isInteger(item.quantity) || item.quantity < 1) return null;
    if (item.selling_plan && !/^[1-9]\d*$/.test(String(item.selling_plan))) return null;
    return payload;
  }

  function genericATCFeedback(form, text, review, isError){
    var status = form.querySelector('[data-mnl-atc-feedback]');
    if (!status) {
      status = document.createElement('p');
      status.dataset.mnlAtcFeedback = '';
      form.appendChild(status);
    }
    status.setAttribute('role', isError ? 'alert' : 'status');
    status.textContent = text || '';
    status.hidden = !text;
    if (review) {
      var link = document.createElement('a');
      link.href = window.MNL_CART && typeof window.MNL_CART.cartUrl === 'function' ? window.MNL_CART.cartUrl() : '/cart';
      link.textContent = MNL_T('cart.js_verify', 'Vérifier le panier');
      status.appendChild(document.createTextNode(' '));
      status.appendChild(link);
    }
  }

  document.addEventListener('submit', function(e){
    var form = e.target;
    if (e.defaultPrevented || !form || form.tagName !== 'FORM') return;
    if (form.hasAttribute && form.hasAttribute('data-mnl-native-atc')) return;
    var action;
    try { action = new URL(form.action, window.location.origin); } catch (_) { return; }
    if (action.origin !== window.location.origin || String(form.method).toLowerCase() !== 'post' || !/(?:^|\/)cart\/add(?:\.js)?\/?$/.test(action.pathname)) return;
    var payload;
    try { payload = genericATCPayload(new FormData(form)); } catch (_) { payload = null; }
    if (!payload) return;
    e.preventDefault();
    var state = genericATCState.get(form);
    if (!state) { state = { busy: false }; genericATCState.set(form, state); }
    if (state.busy) return;
    if (!window.MNL_CART || typeof window.MNL_CART.add !== 'function' || typeof window.MNL_CART.read !== 'function' || typeof window.MNL_CART.hasPending !== 'function') {
      genericATCFeedback(form, MNL_T('header-polish.cart_atc_error_title', 'Ajout impossible') + '. ' + MNL_T('header-polish.cart_atc_error_sub', 'Réessaie dans un instant'), true, true);
      return;
    }
    if (window.MNL_CART.hasPending()) {
      genericATCFeedback(form, MNL_T('cart.js_uncertain', 'La mise à jour reste incertaine. Vérifie le panier avant de poursuivre : aucune nouvelle modification ne sera envoyée.'), true, true);
      return;
    }
    state.busy = true;
    var previousBusy = form.getAttribute('aria-busy');
    var buttons = Array.prototype.map.call(form.querySelectorAll('button[type="submit"], input[type="submit"], button:not([type])'), function(button){
      var value = { element: button, disabled: button.disabled };
      button.disabled = true;
      return value;
    });
    form.setAttribute('aria-busy', 'true');
    genericATCFeedback(form, MNL_T('header-polish.cart_updating', 'Mise à jour du panier…'), false, false);
    var confirmed = false;
    Promise.resolve().then(function(){ return window.MNL_CART.add(payload); })
      .then(function(){
        confirmed = true;
        try {
          var _b = document.querySelector('.mnl-hd-badge');
          if (_b) { _b.classList.remove('is-pop'); void _b.offsetWidth; _b.classList.add('is-pop'); setTimeout(function(){ _b.classList.remove('is-pop'); }, 700); }
        } catch(_) {}
        return window.MNL_CART.read();
      })
      .then(function(cart){
        genericATCFeedback(form, '', false, false);
        renderCart(cart);
        updateCartBadge(cart.item_count);
        openDrawer('cart');
      })
      .catch(function(err){
        console.error('[MNL Header] ATC error:', err);
        var review = confirmed || !!(err && err.uncertain) || window.MNL_CART.hasPending();
        var message = confirmed ? MNL_T('wishlist.js_added_to_cart', 'Ajouté au panier')
          : review ? MNL_T('cart.js_uncertain', 'La mise à jour reste incertaine. Vérifie le panier avant de poursuivre : aucune nouvelle modification ne sera envoyée.')
          : MNL_T('header-polish.cart_atc_error_title', 'Ajout impossible') + '. ' + String(err && err.message || MNL_T('header-polish.cart_atc_error_sub', 'Réessaie dans un instant')).slice(0, 160);
        genericATCFeedback(form, message, review, !confirmed);
      })
      .finally(function(){
        state.busy = false;
        if (previousBusy == null) form.removeAttribute('aria-busy');
        else form.setAttribute('aria-busy', previousBusy);
        buttons.forEach(function(button){ button.element.disabled = button.disabled; });
      });
  });

  /* V980 : tracking begin_checkout au clic « Paiement sécurisé » du tiroir (lien re-rendu à chaque
     refresh → délégation document). AUCUN preventDefault : la navigation <a href="/checkout"> suit. */
  document.addEventListener('click', function(e){
    var t = e.target;
    if (t && t.closest && t.closest('.mnl-hd-cart__checkout')) {
      if (_cartMutating || _promoMutating || _cartNeedsReview) { e.preventDefault(); return; }
      try {
        if (window.gtag) gtag('event', 'begin_checkout', { currency: 'EUR' });
        if (window.fbq) fbq('track', 'InitiateCheckout');
      } catch(_) {}
    }
  });

  /* V1373 : le moteur du configurateur (mnlAddToCart) émet 'mnl:cart:open' quand la page
     n'a ni <cart-drawer> ni <cart-notification> — cas de l'ACCUEIL depuis V1368 (achat
     express sur place). Personne n'écoutait : l'article partait au panier SANS retour
     visuel. Le tiroir du header répond désormais à ce canal. */
  document.addEventListener('mnl:cart:open', function(){ try { openDrawer('cart'); } catch(_){} });
  // Hook custom : autres scripts peuvent dispatcher 'mnl:cart:updated' pour refresh
  // Vague 80 : si l'event vient d'un autre tab via BroadcastChannel (vague 77), on a déjà le count → skip fetch /cart.js
  document.addEventListener('mnl:cart:updated', function(e){
    // V961+ : dispatch interne du tiroir (updateCart) → panier déjà rendu + badge à jour ici même,
    // on ne refetch pas (évite 2 allers-retours /cart.js redondants par clic +/−/Retirer).
    if (e && e.detail && e.detail.source === 'drawer') return;
    // V985c : réutilise le fetch de refreshCart pour le badge au lieu d'en lancer un 2e (avant :
    // 2 GET /cart.js par event → tempête d'appels sur un ATC configurateur, risque 429).
    var p = refreshCart();
    if (e && e.detail && (e.detail.source === 'broadcast-cross-tab' || e.detail.source === 'storage-cross-tab')) {
      // Count déjà reçu via BroadcastChannel — pas besoin de refetch (économie 50-200ms RPC)
      if (typeof e.detail.count === 'number') updateCartBadge(e.detail.count);
      return;
    }
    // V985c : garde « if (cart) » obligatoire — le catch de refreshCart avale l'erreur et résout en undefined.
    if (p && p.then) p.then(function(cart){ if (cart && typeof cart.item_count === 'number') updateCartBadge(cart.item_count); });
  });
  // Hook custom : autres scripts peuvent dispatcher 'mnl:cart:open'
  document.addEventListener('mnl:cart:open', function(){
    openDrawer('cart');
  });

  // ════════════ NEUTRALISE LE CART DRAWER DAWN (one-shot) ════════════
  // Désactive l'auto-open du drawer Shopify natif au load uniquement.
  // PAS de MutationObserver (causait une boucle infinie de re-renders).
  function neutralizeShopifyCartOnce(){
    var nodes = document.querySelectorAll('cart-drawer, cart-notification, .cart-notification, .cart-drawer, #CartDrawer, #cart-notification');
    nodes.forEach(function(n){
      try {
        n.style.display = 'none';
        n.style.visibility = 'hidden';
        if (typeof n.open === 'function') n.open = function(){};
        if (n.classList) n.classList.remove('active', 'animate', 'is-open');
      } catch(e) {}
    });
  }
  // Run once after DOM ready, then once après 800ms pour catch le lazy-load Dawn
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', neutralizeShopifyCartOnce);
  } else {
    neutralizeShopifyCartOnce();
  }
  setTimeout(neutralizeShopifyCartOnce, 800);

  /* V986 : bouton Coach IA header — si le coach est chargé sur la page (mnlOpenAI, PDP/quiz),
     ouverture in-page immédiate ; sinon on laisse le lien naviguer vers ?open=ai. Capture:true
     pour passer avant la navigation smooth globale. */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-mnl-coach-btn]') : null;
    if (!b || e.defaultPrevented) return;
    if (typeof window.mnlOpenAI === 'function') {
      e.preventDefault();
      e.stopPropagation();
      if (hd.dataset.open) closeDrawer();
      closeAccDD();
      window.mnlOpenAI();
    }
  }, true);

})();

